webpackJsonp([1],{

/***/ "/8nE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2HYF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "489H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4o0c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ArfS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B81l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73f1dc7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("r/47")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Dj8j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DlD2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G+8N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hq6V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IM0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b80c1d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("XwPx")
  __webpack_require__("dOfK")
  __webpack_require__("/8nE")
  __webpack_require__("k77+")
  __webpack_require__("DlD2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js + 1 modules
var base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/checklist/object-filter.js
var object_filter = __webpack_require__("q5lo");

// EXTERNAL MODULE: ./node_modules/vux/src/components/radio/props.js
var props = __webpack_require__("Zor0");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["b" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/radio/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var src_components_radio = ({
  name: 'radio',
  mixins: [base["a" /* default */]],
  filters: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    this.handleChangeEvent = true;
  },

  methods: {
    getValue: object_filter["c" /* getValue */],
    getKey: object_filter["a" /* getKey */],
    onFocus: function onFocus() {
      this.currentValue = this.fillValue || '';
      this.isFocus = true;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var isOption = radio_contains(this.options, newVal);
      if (newVal !== '' && isOption) {
        this.fillValue = '';
      }
      this.$emit('on-change', newVal, Object(object_filter["b" /* getLabel */])(this.options, newVal));
      this.$emit('input', newVal);
    },
    fillValue: function fillValue(newVal) {
      if (this.fillMode && this.isFocus) {
        this.currentValue = newVal;
      }
    }
  },
  data: function data() {
    return {
      fillValue: '',
      isFocus: false,
      currentValue: this.value
    };
  }
});

function radio_contains(a, obj) {
  var i = a.length;
  while (i--) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0506500e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/radio/index.vue
var radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cells_radio",class:_vm.disabled ? 'vux-radio-disabled' : ''},[_vm._l((_vm.options),function(one,index){return _c('label',{staticClass:"weui-cell weui-cell_radio weui-check__label",attrs:{"for":("radio_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__bd"},[_vm._t("each-item",function(){return [_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(one && one.icon),expression:"one && one.icon"}],staticClass:"vux-radio-icon",attrs:{"src":one.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label",style:(_vm.currentValue === _vm.getKey(one) ? (_vm.selectedLabelStyle || '') : '')},[_vm._v(_vm._s(_vm._f("getValue")(one)))])])]},{"icon":one.icon,"label":_vm.getValue(one),"index":index,"selected":_vm.currentValue === _vm.getKey(one)})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"radio","id":_vm.disabled ? '' : ("radio_" + _vm.uuid + "_" + index)},domProps:{"value":_vm.getKey(one),"checked":_vm._q(_vm.currentValue,_vm.getKey(one))},on:{"change":function($event){_vm.currentValue=_vm.getKey(one)}}}),_vm._v(" "),_c('span',{staticClass:"weui-icon-checked"})])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fillMode),expression:"fillMode"}],staticClass:"weui-cell"},[_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",attrs:{"for":""}},[_vm._v(_vm._s(_vm.fillLabel))])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.fillValue),expression:"fillValue"}],staticClass:"weui-input needsclick",attrs:{"type":"text","placeholder":_vm.fillPlaceholder},domProps:{"value":(_vm.fillValue)},on:{"blur":function($event){_vm.isFocus=false},"focus":function($event){return _vm.onFocus()},"input":function($event){if($event.target.composing){ return; }_vm.fillValue=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value==='' && !_vm.isFocus),expression:"value==='' && !isFocus"}],staticClass:"weui-cell__ft"},[_c('i',{staticClass:"weui-icon-warn"})])])],2)}
var radio_staticRenderFns = []
var radio_esExports = { render: radio_render, staticRenderFns: radio_staticRenderFns }
/* harmony default export */ var vux_src_components_radio = (radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/radio/index.vue
function radio_injectStyle (ssrContext) {
  __webpack_require__("fFUN")
}
var radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var radio___vue_template_functional__ = false
/* styles */
var radio___vue_styles__ = radio_injectStyle
/* scopeId */
var radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var radio___vue_module_identifier__ = null
var radio_Component = radio_normalizeComponent(
  src_components_radio,
  vux_src_components_radio,
  radio___vue_template_functional__,
  radio___vue_styles__,
  radio___vue_scopeId__,
  radio___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_radio = (radio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/view-box/index.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_view_box = ({
  name: 'view-box',
  props: ['bodyPaddingTop', 'bodyPaddingBottom'],
  methods: {
    scrollTo: function scrollTo(top) {
      this.$refs.viewBoxBody.scrollTop = top;
    },
    getScrollTop: function getScrollTop() {
      return this.$refs.viewBoxBody.scrollTop;
    },
    getScrollBody: function getScrollBody() {
      return this.$refs.viewBoxBody;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dfa359e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/view-box/index.vue
var view_box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-tab"},[_vm._t("header"),_vm._v(" "),_c('div',{ref:"viewBoxBody",staticClass:"weui-tab__panel vux-fix-safari-overflow-scrolling",style:({paddingTop: _vm.bodyPaddingTop, paddingBottom: _vm.bodyPaddingBottom}),attrs:{"id":"vux_view_box_body"}},[_vm._t("default")],2),_vm._v(" "),_vm._t("bottom")],2)}
var view_box_staticRenderFns = []
var view_box_esExports = { render: view_box_render, staticRenderFns: view_box_staticRenderFns }
/* harmony default export */ var src_components_view_box = (view_box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/view-box/index.vue
function view_box_injectStyle (ssrContext) {
  __webpack_require__("G+8N")
}
var view_box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var view_box___vue_template_functional__ = false
/* styles */
var view_box___vue_styles__ = view_box_injectStyle
/* scopeId */
var view_box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var view_box___vue_module_identifier__ = null
var view_box_Component = view_box_normalizeComponent(
  components_view_box,
  src_components_view_box,
  view_box___vue_template_functional__,
  view_box___vue_styles__,
  view_box___vue_scopeId__,
  view_box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_view_box = (view_box_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347cf7be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var group_staticRenderFns = []
var group_esExports = { render: group_render, staticRenderFns: group_staticRenderFns }
/* harmony default export */ var src_components_group = (group_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function group_injectStyle (ssrContext) {
  __webpack_require__("XcBy")
}
var group_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group___vue_template_functional__ = false
/* styles */
var group___vue_styles__ = group_injectStyle
/* scopeId */
var group___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group___vue_module_identifier__ = null
var group_Component = group_normalizeComponent(
  components_group,
  src_components_group,
  group___vue_template_functional__,
  group___vue_styles__,
  group___vue_scopeId__,
  group___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = (group_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/box/index.vue
//
//
//
//

/* harmony default export */ var box = ({
  name: 'box',
  props: {
    gap: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/box/index.vue
//
//
//
//

/* harmony default export */ var components_box = ({
  name: 'box',
  props: {
    gap: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d06311b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/box/index.vue
var box_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({margin:_vm.gap})},[_vm._t("default")],2)}
var box_staticRenderFns = []
var box_esExports = { render: box_render, staticRenderFns: box_staticRenderFns }
/* harmony default export */ var src_components_box = (box_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/box/index.vue
var box_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var box___vue_template_functional__ = false
/* styles */
var box___vue_styles__ = null
/* scopeId */
var box___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var box___vue_module_identifier__ = null
var box_Component = box_normalizeComponent(
  components_box,
  src_components_box,
  box___vue_template_functional__,
  box___vue_styles__,
  box___vue_scopeId__,
  box___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_box = (box_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ed96448","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var icon_staticRenderFns = []
var icon_esExports = { render: icon_render, staticRenderFns: icon_staticRenderFns }
/* harmony default export */ var src_components_icon = (icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function icon_injectStyle (ssrContext) {
  __webpack_require__("2HYF")
}
var icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var icon___vue_template_functional__ = false
/* styles */
var icon___vue_styles__ = icon_injectStyle
/* scopeId */
var icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var icon___vue_module_identifier__ = null
var icon_Component = icon_normalizeComponent(
  components_icon,
  src_components_icon,
  icon___vue_template_functional__,
  icon___vue_styles__,
  icon___vue_scopeId__,
  icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = (icon_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var toast = __webpack_require__("rLAy");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d40071a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var inline_desc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var inline_desc_staticRenderFns = []
var inline_desc_esExports = { render: inline_desc_render, staticRenderFns: inline_desc_staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (inline_desc_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function inline_desc_injectStyle (ssrContext) {
  __webpack_require__("uyKd")
}
var inline_desc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_desc___vue_template_functional__ = false
/* styles */
var inline_desc___vue_styles__ = inline_desc_injectStyle
/* scopeId */
var inline_desc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_desc___vue_module_identifier__ = null
var inline_desc_Component = inline_desc_normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  inline_desc___vue_template_functional__,
  inline_desc___vue_styles__,
  inline_desc___vue_scopeId__,
  inline_desc___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = (inline_desc_Component.exports);

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8c8891a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",function(){return [(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()]})],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"touchstart":function($event){return _vm.clear.apply(null, arguments)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon.apply(null, arguments)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("ArfS")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = (x_input_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var cell_props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(cell_props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(cell_props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-921916da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",function(){return [_vm._v(_vm._s(_vm.inlineDesc))]})],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]}),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("4o0c")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js + 1 modules
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696d4120","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("Hq6V")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// EXTERNAL MODULE: ./node_modules/array-find/find.js
var find = __webpack_require__("NXHL");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var _cellProps = Object(cell_props["a" /* default */])();
delete _cellProps.value;

/* harmony default export */ var popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Cell: vux_src_components_cell
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, _cellProps, Object(props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-radio/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var popup_radio__cellProps = Object(cell_props["a" /* default */])();
delete popup_radio__cellProps.value;

/* harmony default export */ var components_popup_radio = ({
  name: 'popup-radio',
  components: {
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Cell: vux_src_components_cell
  },
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  props: extends_default()({
    placeholder: String,
    readonly: Boolean
  }, popup_radio__cellProps, Object(props["a" /* default */])()),
  computed: {
    displayValue: function displayValue() {
      var _this = this;

      if (!this.options.length) {
        return '';
      }
      if (typeof_default()(this.options[0]) === 'object') {
        var match = find_default()(this.options, function (option) {
          return option.key === _this.currentValue;
        });
        if (match) {
          return match.value;
        }
      }
      return this.currentValue;
    }
  },
  methods: {
    onValueChange: function onValueChange(val) {
      this.hide();
    },
    show: function show() {
      if (!this.readonly) {
        this.showPopup = true;
      }
    },
    hide: function hide() {
      this.showPopup = false;
    }
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      showPopup: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f92ebd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-radio/index.vue
var popup_radio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cell',{attrs:{"title":_vm.title,"value":_vm.currentValue,"is-link":!_vm.readonly,"value-align":_vm.valueAlign,"border-intent":_vm.borderIntent},nativeOn:{"click":function($event){return _vm.show.apply(null, arguments)}}},[(!_vm.displayValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.displayValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayValue))]):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"icon"},slot:"icon"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('popup',{staticStyle:{"background-color":"#fff"},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}},[_vm._t("popup-header",null,{"options":_vm.options,"value":_vm.currentValue}),_vm._v(" "),_c('radio',{attrs:{"options":_vm.options,"fill-mode":false},on:{"on-change":_vm.onValueChange},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_vm._t("each-item",function(){return [_c('p',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(props.icon),expression:"props.icon"}],staticClass:"vux-radio-icon",attrs:{"src":props.icon}}),_vm._v(" "),_c('span',{staticClass:"vux-radio-label"},[_vm._v(_vm._s(props.label))])])]},{"icon":props.icon,"label":props.label,"index":props.index})]}}],null,true),model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})],2)],1)])}
var popup_radio_staticRenderFns = []
var popup_radio_esExports = { render: popup_radio_render, staticRenderFns: popup_radio_staticRenderFns }
/* harmony default export */ var src_components_popup_radio = (popup_radio_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-radio/index.vue
function popup_radio_injectStyle (ssrContext) {
  __webpack_require__("IM0P")
}
var popup_radio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_radio___vue_template_functional__ = false
/* styles */
var popup_radio___vue_styles__ = popup_radio_injectStyle
/* scopeId */
var popup_radio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_radio___vue_module_identifier__ = null
var popup_radio_Component = popup_radio_normalizeComponent(
  components_popup_radio,
  src_components_popup_radio,
  popup_radio___vue_template_functional__,
  popup_radio___vue_styles__,
  popup_radio___vue_scopeId__,
  popup_radio___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_radio = (popup_radio_Component.exports);

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26523019","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]}),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){return _vm.$emit('on-click-title')}}},[_vm._t("default",function(){return [_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])]})],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){return _vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var x_header_staticRenderFns = []
var x_header_esExports = { render: x_header_render, staticRenderFns: x_header_staticRenderFns }
/* harmony default export */ var src_components_x_header = (x_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function x_header_injectStyle (ssrContext) {
  __webpack_require__("489H")
}
var x_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_header___vue_template_functional__ = false
/* styles */
var x_header___vue_styles__ = x_header_injectStyle
/* scopeId */
var x_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_header___vue_module_identifier__ = null
var x_header_Component = x_header_normalizeComponent(
  components_x_header,
  src_components_x_header,
  x_header___vue_template_functional__,
  x_header___vue_styles__,
  x_header___vue_scopeId__,
  x_header___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (x_header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-283ca23f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("oXsw")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/cookie/index.js
var cookie = __webpack_require__("17Ff");

// EXTERNAL MODULE: ./node_modules/vux/src/components/loading/index.vue + 3 modules
var loading = __webpack_require__("Bfwr");

// CONCATENATED MODULE: ./src/utils/constants.js
var BANKS = {
  100: 'Maybank',
  101: 'Public Bank',
  102: 'CIMB Bank',
  103: 'Hong Leong',
  104: 'RHB',
  105: 'AmBank',
  106: 'KBank',
  107: 'Bankok Bank',
  108: 'SCB',
  109: 'Krung Thai',
  110: 'Ayudhya',
  111: 'GSBank',
  112: 'TMB Bank',
  113: 'CIMB Thai',
  114: 'Kiatnakin',
  115: 'Techcombank',
  116: 'Sacombank',
  117: 'Vietcombank',
  118: 'ACB',
  119: 'DongA Bank',
  120: 'VietinBank',
  121: 'BIDV',
  122: 'Eximbank',
  123: 'BCA',
  124: 'BNI',
  125: 'BRI',
  126: 'Mandiri Bank',
  127: 'CIMB',
  128: 'VPBank',
  129: 'MBBank',
  130: 'TPBank',
  131: 'Agribank',
  132: 'LienVietPostBank',
  133: 'SHBANK',
  134: 'PVcombank',
  135: 'SAIGON BANK',
  136: 'SeABank',
  137: 'ABBANK',
  138: 'BAC A BANK',
  139: 'Viet Capital Bank',
  140: 'MSB',
  141: 'Kienlongbank',
  142: 'NamABank',
  143: 'NCB',
  144: 'HDBank',
  145: 'OCB',
  146: 'VIB',
  147: 'SCB',
  148: 'Saigonbank',
  149: 'VietABank',
  150: 'BAOVIETBank',
  151: 'Vietbank',
  152: 'PG Bank',
  1000: 'All banks support'
};
// CONCATENATED MODULE: ./src/utils/helpers.js
var needBankTypes = [12, 13, 14];
var isNeedBank = function isNeedBank(typeId) {
  return needBankTypes.includes(typeId);
};
var numberWithCommas = function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit.vue




















/* harmony default export */ var Deposit = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Loading: loading["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    document.body.className = 'charge';
  },
  data: function data() {
    return {
      typeoption: [],
      typeid: null,
      channels: [],
      channelsfilter: [],
      channel_key: null,
      showChannel: false,
      banksoption: [],
      banksfilter: [],
      bank_key: null,
      needBank: null,
      showBank: false,
      havebankid: false,
      titlechoose: 'Chọn ngân hàng',
      channeldesc: '',
      channelmin: null,
      channelmax: null,
      orientpos: false,
      rotate: false,
      query: '',
      title: '充值',
      platform_show: {
        desc: ''
      },
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showTypeSelect: false,
      code: null,
      serial: null,
      need_bank: null,
      need_scratchcard: 0,
      bank_id: null,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      videoon: false,
      videooff: true,
      popvid: false,
      need_name: false
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    this.handleOrientationChange();
    window.addEventListener('orientationchange', this.handleOrientationChange);
    this.checkOrderCounts();
    var self = this;
    self.channel_key = typeof self.$route.query.platform_id === 'undefined' ? 1 : JSON.parse(self.$route.query.platform_id);

    self.$models.Deposit.info({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (typePlatforms) {
      self.checkDepositExists(typePlatforms.data.data);
      self.rotate = typePlatforms.data.data.rotate_prompt;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(typePlatforms.data.data.types), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var typePlatform = _step.value;

          var typelist = {
            key: typePlatform.type_id,
            value: typePlatform.display_name,
            icon: 'static/images/logo/' + typePlatform.icon + '.png',
            isfeatured: typePlatform.is_featured
          };
          var channellist = {};
          if (!isNeedBank(typePlatform.type_id)) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(typePlatform.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var typemobileshow = _step2.value;

                var showmobile, defaultmobile;
                showmobile = typemobileshow.mobile_show;
                defaultmobile = typemobileshow.mobile_default;
                channellist = {
                  show_view: Boolean(showmobile),
                  default_show: Boolean(defaultmobile),
                  key: typemobileshow.id,
                  value: typemobileshow.name,
                  bank_id: typemobileshow.bank_id,
                  banks: typemobileshow.banks,
                  amount_list: typemobileshow.custom_amounts,
                  description: typemobileshow.description,
                  icon: 'static/images/logo/' + typemobileshow.icon + '.png',
                  max_load: typemobileshow.max_load,
                  min_load: typemobileshow.min_load,
                  need_bank: typemobileshow.need_bank,
                  static_amount: typemobileshow.static_amount,
                  type_id: typemobileshow.type_id,
                  need_scratchcard: typemobileshow.need_scratchcard,
                  need_name: typemobileshow.need_name
                };
                self.channels = self.channels.concat(channellist);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            self.typeoption = self.typeoption.concat(typelist);
          } else {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = get_iterator_default()(typePlatform.data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _typemobileshow = _step3.value;

                var bankshortname = BANKS[_typemobileshow.icon];
                if (bankshortname === '' || bankshortname === undefined) {
                  bankshortname = _typemobileshow.name;
                }
                var banklist = {
                  key: _typemobileshow.icon,
                  value: bankshortname,
                  icon: 'static/images/vnbanks/icons/' + _typemobileshow.icon + '.png',
                  children: _typemobileshow.children,
                  type_id: typePlatform.type_id
                };
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                  for (var _iterator4 = get_iterator_default()(_typemobileshow.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var typemobileshow2 = _step4.value;

                    showmobile = typemobileshow2.mobile_show;
                    defaultmobile = typemobileshow2.mobile_default;
                    channellist = {
                      show_view: Boolean(showmobile),
                      default_show: Boolean(defaultmobile),
                      key: typemobileshow2.id,
                      value: typemobileshow2.name,
                      bank_id: typemobileshow2.bank_id,
                      banks: typemobileshow2.banks,
                      amount_list: typemobileshow2.custom_amounts,
                      description: typemobileshow2.description,
                      icon: 'static/images/logo/' + typemobileshow2.icon + '.png',
                      max_load: typemobileshow2.max_load,
                      min_load: typemobileshow2.min_load,
                      need_bank: typemobileshow2.need_bank,
                      static_amount: typemobileshow2.static_amount,
                      type_id: typemobileshow2.type_id,
                      related_bankid: _typemobileshow.icon,
                      related_bankname: _typemobileshow.name,
                      need_scratchcard: typemobileshow2.need_scratchcard,
                      need_name: typemobileshow2.need_name
                    };
                    self.channels = self.channels.concat(channellist);
                  }
                } catch (err) {
                  _didIteratorError4 = true;
                  _iteratorError4 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                      _iterator4.return();
                    }
                  } finally {
                    if (_didIteratorError4) {
                      throw _iteratorError4;
                    }
                  }
                }

                self.banksoption = self.banksoption.concat(banklist);
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            self.typeoption = self.typeoption.concat(typelist);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (['', null, '0.00'].includes(typePlatforms.data.data.amount)) {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = typePlatforms.data.data.amount;
      }
      self.app_order_no = typePlatforms.data.data.app_order_no;
      if (self.typeoption.length === 0) {
        self.$router.replace({
          path: '/error',
          query: {
            title: 'Ngân hàng này đang bảo trì.<br />Vui lòng quay lại sau.',
            description1: '\u0110\u1EB7t h\xE0ng\uFF1A' + typePlatforms.data.data.app_order_no,
            description2: 'C\xE1c lo\u1EA1i thanh to\xE1n\uFF1A ' + (typePlatforms.data.data.type === null ? 'Không có kênh nào tại thời gian này' : typePlatforms.data.data.type)
          }
        });
      } else if (self.typeoption.length === 1) {
        self.typeid = self.typeoption[0]['key'];
        if (typePlatforms.data.data.bank_id === null) {
          self.havebankid = false;
          self.listChannel(self.typeid);
          if (!(self.showAmountInput === true || isNeedBank(self.typeid) && self.banksfilter.length > 1 || self.channelsfilter.length > 1)) {
            self.check();
          }
        } else {
          self.havebankid = true;
          self.bank_key = typePlatforms.data.data.bank_id;
          self.listChannel(self.typeid);
          self.listbankchannel(typePlatforms.data.data.bank_id);
          if (!(self.showAmountInput === true || self.channelsfilter.length > 1)) {
            self.check();
          }
        }
      } else if (self.typeoption.length > 1) {
        self.typeid = self.typeoption[0]['key'];
        self.listChannel(self.typeid);
        if (isNeedBank(self.typeid)) {
          self.listbankchannel(self.banksfilter[0]['key']);
          self.bank_key = self.banksfilter[0]['key'];
        }
      }
    });

    sessionStorage.setItem('prev', this.$route.fullPath);
  },

  methods: {
    checkDepositExists: function checkDepositExists(orderInfo) {

      if (orderInfo === undefined || orderInfo === '') {
        this.$router.replace({
          path: '/error',
          query: {
            title: 'Đơn hàng không tồn tại',
            description1: 'Lỗi'
          }
        });
      }

      var hasDeposit = orderInfo.has_deposit,
          appOrderNumber = orderInfo.app_order_no;

      if (hasDeposit) {
        this.$router.replace({
          path: '/error',
          query: {
            title: 'Đơn hàng đã tồn tại',
            description1: '\u0110\u1EB7t h\xE0ng\uFF1A' + appOrderNumber
          }
        });
      }
    },
    handleOrientationChange: function handleOrientationChange() {
      var isRotate = window.screen.orientation && window.screen.orientation.angle > 0 || !window.matchMedia('(orientation: portrait)').matches;

      this.orientpos = /Android|iPhone|iPad|iPod|iOS|BlackBerry|IEMobile/i.test(navigator.userAgent) ? isRotate : false;
    },
    closeIt: function closeIt() {
      this.orientpos = false;
    },
    helpcenter: function helpcenter() {
      this.videoon = true;
      this.videooff = false;
    },
    backtomain: function backtomain() {
      this.videoon = false;
      this.videooff = true;
    },
    closevid: function closevid() {
      var video = document.getElementById('videoinfo');
      video.removeAttribute('src');
      this.popvid = false;
    },
    viewvideo: function viewvideo(videoname) {
      this.popvid = true;
      setTimeout(function () {
        var video = document.getElementById('videoinfo');
        video.setAttribute('type', 'video/mp4');
        video.setAttribute('src', 'static/images/helpcenter/' + videoname + '.mp4');
        video.load();
        video.play();
      }, 500);
    },
    listChannel: function listChannel(typeid) {
      this.typeid = typeid;
      if (!isNeedBank(typeid)) {
        this.showChannel = true;
        this.channel_key = null;
        this.bank_key = null;
        this.channelsfilter = [];
        this.showBank = false;
        this.banksfilter = [];
        this.channelmin = null;
        this.channelmax = null;
        this.showTypeSelect = false;
        this.need_scratchcard = null;
        this.need_name = false;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = get_iterator_default()(this.channels), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var channelshow = _step5.value;

            if (typeid === channelshow.type_id) {
              this.channelsfilter = this.channelsfilter.concat(channelshow);
              if (channelshow.default_show) {
                this.channel_key = channelshow.key;
                this.channelmin = channelshow.min_load;
                this.channelmax = channelshow.max_load;
                this.needBank = channelshow.need_bank;
                this.channeldesc = channelshow.description;
                this.need_scratchcard = channelshow.need_scratchcard;
                this.need_name = channelshow.need_name;
              } else {
                this.channel_key = this.channelsfilter[0]['key'];
                this.channelmin = this.channelsfilter[0]['min_load'];
                this.channelmax = this.channelsfilter[0]['max_load'];
                this.needBank = this.channelsfilter[0]['need_bank'];
                this.channeldesc = this.channelsfilter[0]['description'];
                this.need_scratchcard = this.channelsfilter[0]['need_scratchcard'];
                this.need_name = this.channelsfilter[0]['need_name'];
              }
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      } else {
        this.showBank = false;
        this.banksfilter = [];
        if (typeid === 14) {
          this.titlechoose = 'Chọn loại thẻ';
          this.handleLoadCardTypeSelect();
        } else {
          this.titlechoose = 'Chọn ngân hàng';
          this.showTypeSelect = false;
          this.code = null;
          this.serial = null;
        }
        if (this.havebankid === false) {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(this.banksoption), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var bankshow = _step6.value;

              if (typeid === bankshow.type_id) {
                this.banksfilter = this.banksfilter.concat(bankshow);
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }

          this.bank_key = this.banksfilter[0]['key'];
          this.listbankchannel(this.bank_key);
        } else {
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = get_iterator_default()(this.banksoption), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _bankshow = _step7.value;

              if (typeid === _bankshow.type_id && this.bank_key === _bankshow.key) {
                this.banksfilter = this.banksfilter.concat(_bankshow);
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
        this.showBank = true;
        this.showChannel = true;
      }
    },
    listbankchannel: function listbankchannel(bankkey) {
      this.showChannel = false;
      this.channel_key = null;
      this.channelsfilter = [];
      this.channelmin = null;
      this.channelmax = null;
      this.needBank = null;
      this.need_scratchcard = null;
      this.need_name = false;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(this.channels), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var bankchannelshow = _step8.value;

          if (bankchannelshow.type_id === this.typeid && bankchannelshow.related_bankid === bankkey) {
            this.channelsfilter = this.channelsfilter.concat(bankchannelshow);
            if (bankchannelshow.default_show) {
              this.channel_key = bankchannelshow.key;
              this.channelmin = bankchannelshow.min_load;
              this.channelmax = bankchannelshow.max_load;
              this.needBank = bankchannelshow.need_bank;
              this.channeldesc = bankchannelshow.description;
              this.need_scratchcard = bankchannelshow.need_scratchcard;
              this.need_name = bankchannelshow.need_name;
            } else {
              this.channel_key = this.channelsfilter[0]['key'];
              this.channelmin = this.channelsfilter[0]['min_load'];
              this.channelmax = this.channelsfilter[0]['max_load'];
              this.needBank = this.channelsfilter[0]['need_bank'];
              this.channeldesc = this.channelsfilter[0]['description'];
              this.need_scratchcard = this.channelsfilter[0]['need_scratchcard'];
              this.need_name = this.channelsfilter[0]['need_name'];
            }
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      if (bankkey !== null) {
        this.showChannel = true;
      }
    },
    channelselect: function channelselect(channelkey) {
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = get_iterator_default()(this.channels), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var selectchannel = _step9.value;

          if (this.bank_key === null) {
            if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key) {
              this.channelmin = selectchannel.min_load;
              this.channelmax = selectchannel.max_load;
              this.needBank = selectchannel.need_bank;
              this.channeldesc = selectchannel.description;
              this.need_scratchcard = selectchannel.need_scratchcard;
              this.need_name = selectchannel.need_name;
            }
          } else {
            if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key && this.bank_key === selectchannel.related_bankid) {
              this.channelmin = selectchannel.min_load;
              this.channelmax = selectchannel.max_load;
              this.needBank = selectchannel.need_bank;
              this.channeldesc = selectchannel.description;
              this.need_scratchcard = selectchannel.need_scratchcard;
              this.need_name = selectchannel.need_name;
              this.handleLoadCardTypeSelect();
            }
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    },
    check: function check() {
      this.$vux.loading.show({
        text: 'Loading'
      });
      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.channelmin;
      var maxLoad = this.channelmax;
      if (this.bank_key === null && (this.typeid === 12 || this.typeid === 13)) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng chọn ngân hàng！',
          'type': 'warn'
        });
        return;
      }

      if (this.bank_key === null && this.typeid === 14) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng chọn loại thẻ！',
          'type': 'warn'
        });
        return;
      }
      if (this.showTypeSelect === true && (this.code === null || this.code.trim() === '' || this.serial === null || this.serial.trim() === '')) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng nhập Mã thẻ và số seri！',
          'type': 'warn'
        });
        return;
      }

      if (this.need_name && this.name === '') {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng nhập tên thật！',
          'type': 'warn'
        });
        return;
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        this.submit(submitAmout);
      } else {
        this.$vux.loading.hide();
        this.$vux.alert.show({
          content: 'Hỗ trợ nạp tiền ' + minLoad + 'VND ~ ' + maxLoad + ' VND '
        });
      }
    },
    generalDepositCreateParams: function generalDepositCreateParams(amount) {
      var self = this;
      return {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.channel_key,
        bank_id: self.bank_key,
        name: self.name,
        amount: amount,
        bank_card_no: self.bank_card_no
      };
    },
    vinaPhoneCardDepositCreateParams: function vinaPhoneCardDepositCreateParams(amount) {
      var self = this;
      return {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.channel_key,
        bank_id: self.bank_key,
        name: self.name,
        amount: amount,
        serial: self.serial,
        code: self.code,
        type: self.bank_key
      };
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;
      var params = this.need_scratchcard ? this.vinaPhoneCardDepositCreateParams(submitAmout) : this.generalDepositCreateParams(submitAmout);

      self.$models.Deposit.create(params).then(function (response) {
        self.pay_click = false;
        if (!response.data.success) {
          self.$vux.loading.hide();
          self.$router.replace({
            path: '/error',
            query: {
              title: response.data.message,
              description1: 'Đặt hàng：' + self.app_order_no,
              description2: 'Kênh số：#' + self.channel_key,
              description3: ''
            }
          });
          return;
        }
        cookie["a" /* default */].remove('historys');
        self.load_url = response.data.data.load_url;
        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          return;
        } else if (response.data.data.load_straight === 2) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url,
              deposit_type: response.data.data.deposit_type,
              platform_id: self.channel_key,
              from_url: self.$route.path
            }
          });
          return;
        }
        if (self.need_scratchcard && self.typeid === 14) {
          self.$router.replace({ path: '/finished' });
          return;
        }

        self.showPayPage = true;
        setTimeout(function () {
          self.$vux.loading.hide();
        }, 2000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: 'Vui lòng hoàn tất thanh toán trong cửa sổ mở mới<br />Nếu đã hoàn tất, hãy nhấp vào "hoàn tất thanh toán"',
        confirmText: 'Hoàn tất thanh toán',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: 'Đơn đặt hàng được bắt đầu quá thường xuyên',
              description1: 'Xin lỗi vì bạn thường xuyên đặt hàng nhưng không gửi thanh toán',
              description2: 'Xin vui lòng mất năm phút nghỉ để thử lại, cảm ơn bạn đã hợp tác của bạn'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
        console.log(historys);
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },

    numberWithCommas: numberWithCommas,
    handleLoadCardTypeSelect: function handleLoadCardTypeSelect() {
      this.code = null;
      this.serial = null;
      this.showTypeSelect = this.typeid === 14 && this.need_scratchcard === 1;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit.vue




















/* harmony default export */ var components_Deposit = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Loading: loading["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    document.body.className = 'charge';
  },
  data: function data() {
    return {
      typeoption: [],
      typeid: null,
      channels: [],
      channelsfilter: [],
      channel_key: null,
      showChannel: false,
      banksoption: [],
      banksfilter: [],
      bank_key: null,
      needBank: null,
      showBank: false,
      havebankid: false,
      titlechoose: 'Chọn ngân hàng',
      channeldesc: '',
      channelmin: null,
      channelmax: null,
      orientpos: false,
      rotate: false,
      query: '',
      title: '充值',
      platform_show: {
        desc: ''
      },
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showTypeSelect: false,
      code: null,
      serial: null,
      need_bank: null,
      need_scratchcard: 0,
      bank_id: null,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      videoon: false,
      videooff: true,
      popvid: false,
      need_name: false
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    this.handleOrientationChange();
    window.addEventListener('orientationchange', this.handleOrientationChange);
    this.checkOrderCounts();
    var self = this;
    self.channel_key = typeof self.$route.query.platform_id === 'undefined' ? 1 : JSON.parse(self.$route.query.platform_id);

    self.$models.Deposit.info({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (typePlatforms) {
      self.checkDepositExists(typePlatforms.data.data);
      self.rotate = typePlatforms.data.data.rotate_prompt;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(typePlatforms.data.data.types), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var typePlatform = _step.value;

          var typelist = {
            key: typePlatform.type_id,
            value: typePlatform.display_name,
            icon: 'static/images/logo/' + typePlatform.icon + '.png',
            isfeatured: typePlatform.is_featured
          };
          var channellist = {};
          if (!isNeedBank(typePlatform.type_id)) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(typePlatform.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var typemobileshow = _step2.value;

                var showmobile, defaultmobile;
                showmobile = typemobileshow.mobile_show;
                defaultmobile = typemobileshow.mobile_default;
                channellist = {
                  show_view: Boolean(showmobile),
                  default_show: Boolean(defaultmobile),
                  key: typemobileshow.id,
                  value: typemobileshow.name,
                  bank_id: typemobileshow.bank_id,
                  banks: typemobileshow.banks,
                  amount_list: typemobileshow.custom_amounts,
                  description: typemobileshow.description,
                  icon: 'static/images/logo/' + typemobileshow.icon + '.png',
                  max_load: typemobileshow.max_load,
                  min_load: typemobileshow.min_load,
                  need_bank: typemobileshow.need_bank,
                  static_amount: typemobileshow.static_amount,
                  type_id: typemobileshow.type_id,
                  need_scratchcard: typemobileshow.need_scratchcard,
                  need_name: typemobileshow.need_name
                };
                self.channels = self.channels.concat(channellist);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            self.typeoption = self.typeoption.concat(typelist);
          } else {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = get_iterator_default()(typePlatform.data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _typemobileshow = _step3.value;

                var bankshortname = BANKS[_typemobileshow.icon];
                if (bankshortname === '' || bankshortname === undefined) {
                  bankshortname = _typemobileshow.name;
                }
                var banklist = {
                  key: _typemobileshow.icon,
                  value: bankshortname,
                  icon: 'static/images/vnbanks/icons/' + _typemobileshow.icon + '.png',
                  children: _typemobileshow.children,
                  type_id: typePlatform.type_id
                };
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                  for (var _iterator4 = get_iterator_default()(_typemobileshow.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var typemobileshow2 = _step4.value;

                    showmobile = typemobileshow2.mobile_show;
                    defaultmobile = typemobileshow2.mobile_default;
                    channellist = {
                      show_view: Boolean(showmobile),
                      default_show: Boolean(defaultmobile),
                      key: typemobileshow2.id,
                      value: typemobileshow2.name,
                      bank_id: typemobileshow2.bank_id,
                      banks: typemobileshow2.banks,
                      amount_list: typemobileshow2.custom_amounts,
                      description: typemobileshow2.description,
                      icon: 'static/images/logo/' + typemobileshow2.icon + '.png',
                      max_load: typemobileshow2.max_load,
                      min_load: typemobileshow2.min_load,
                      need_bank: typemobileshow2.need_bank,
                      static_amount: typemobileshow2.static_amount,
                      type_id: typemobileshow2.type_id,
                      related_bankid: _typemobileshow.icon,
                      related_bankname: _typemobileshow.name,
                      need_scratchcard: typemobileshow2.need_scratchcard,
                      need_name: typemobileshow2.need_name
                    };
                    self.channels = self.channels.concat(channellist);
                  }
                } catch (err) {
                  _didIteratorError4 = true;
                  _iteratorError4 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                      _iterator4.return();
                    }
                  } finally {
                    if (_didIteratorError4) {
                      throw _iteratorError4;
                    }
                  }
                }

                self.banksoption = self.banksoption.concat(banklist);
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            self.typeoption = self.typeoption.concat(typelist);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (['', null, '0.00'].includes(typePlatforms.data.data.amount)) {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = typePlatforms.data.data.amount;
      }
      self.app_order_no = typePlatforms.data.data.app_order_no;
      if (self.typeoption.length === 0) {
        self.$router.replace({
          path: '/error',
          query: {
            title: 'Ngân hàng này đang bảo trì.<br />Vui lòng quay lại sau.',
            description1: '\u0110\u1EB7t h\xE0ng\uFF1A' + typePlatforms.data.data.app_order_no,
            description2: 'C\xE1c lo\u1EA1i thanh to\xE1n\uFF1A ' + (typePlatforms.data.data.type === null ? 'Không có kênh nào tại thời gian này' : typePlatforms.data.data.type)
          }
        });
      } else if (self.typeoption.length === 1) {
        self.typeid = self.typeoption[0]['key'];
        if (typePlatforms.data.data.bank_id === null) {
          self.havebankid = false;
          self.listChannel(self.typeid);
          if (!(self.showAmountInput === true || isNeedBank(self.typeid) && self.banksfilter.length > 1 || self.channelsfilter.length > 1)) {
            self.check();
          }
        } else {
          self.havebankid = true;
          self.bank_key = typePlatforms.data.data.bank_id;
          self.listChannel(self.typeid);
          self.listbankchannel(typePlatforms.data.data.bank_id);
          if (!(self.showAmountInput === true || self.channelsfilter.length > 1)) {
            self.check();
          }
        }
      } else if (self.typeoption.length > 1) {
        self.typeid = self.typeoption[0]['key'];
        self.listChannel(self.typeid);
        if (isNeedBank(self.typeid)) {
          self.listbankchannel(self.banksfilter[0]['key']);
          self.bank_key = self.banksfilter[0]['key'];
        }
      }
    });

    sessionStorage.setItem('prev', this.$route.fullPath);
  },

  methods: {
    checkDepositExists: function checkDepositExists(orderInfo) {

      if (orderInfo === undefined || orderInfo === '') {
        this.$router.replace({
          path: '/error',
          query: {
            title: 'Đơn hàng không tồn tại',
            description1: 'Lỗi'
          }
        });
      }

      var hasDeposit = orderInfo.has_deposit,
          appOrderNumber = orderInfo.app_order_no;

      if (hasDeposit) {
        this.$router.replace({
          path: '/error',
          query: {
            title: 'Đơn hàng đã tồn tại',
            description1: '\u0110\u1EB7t h\xE0ng\uFF1A' + appOrderNumber
          }
        });
      }
    },
    handleOrientationChange: function handleOrientationChange() {
      var isRotate = window.screen.orientation && window.screen.orientation.angle > 0 || !window.matchMedia('(orientation: portrait)').matches;

      this.orientpos = /Android|iPhone|iPad|iPod|iOS|BlackBerry|IEMobile/i.test(navigator.userAgent) ? isRotate : false;
    },
    closeIt: function closeIt() {
      this.orientpos = false;
    },
    helpcenter: function helpcenter() {
      this.videoon = true;
      this.videooff = false;
    },
    backtomain: function backtomain() {
      this.videoon = false;
      this.videooff = true;
    },
    closevid: function closevid() {
      var video = document.getElementById('videoinfo');
      video.removeAttribute('src');
      this.popvid = false;
    },
    viewvideo: function viewvideo(videoname) {
      this.popvid = true;
      setTimeout(function () {
        var video = document.getElementById('videoinfo');
        video.setAttribute('type', 'video/mp4');
        video.setAttribute('src', 'static/images/helpcenter/' + videoname + '.mp4');
        video.load();
        video.play();
      }, 500);
    },
    listChannel: function listChannel(typeid) {
      this.typeid = typeid;
      if (!isNeedBank(typeid)) {
        this.showChannel = true;
        this.channel_key = null;
        this.bank_key = null;
        this.channelsfilter = [];
        this.showBank = false;
        this.banksfilter = [];
        this.channelmin = null;
        this.channelmax = null;
        this.showTypeSelect = false;
        this.need_scratchcard = null;
        this.need_name = false;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = get_iterator_default()(this.channels), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var channelshow = _step5.value;

            if (typeid === channelshow.type_id) {
              this.channelsfilter = this.channelsfilter.concat(channelshow);
              if (channelshow.default_show) {
                this.channel_key = channelshow.key;
                this.channelmin = channelshow.min_load;
                this.channelmax = channelshow.max_load;
                this.needBank = channelshow.need_bank;
                this.channeldesc = channelshow.description;
                this.need_scratchcard = channelshow.need_scratchcard;
                this.need_name = channelshow.need_name;
              } else {
                this.channel_key = this.channelsfilter[0]['key'];
                this.channelmin = this.channelsfilter[0]['min_load'];
                this.channelmax = this.channelsfilter[0]['max_load'];
                this.needBank = this.channelsfilter[0]['need_bank'];
                this.channeldesc = this.channelsfilter[0]['description'];
                this.need_scratchcard = this.channelsfilter[0]['need_scratchcard'];
                this.need_name = this.channelsfilter[0]['need_name'];
              }
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      } else {
        this.showBank = false;
        this.banksfilter = [];
        if (typeid === 14) {
          this.titlechoose = 'Chọn loại thẻ';
          this.handleLoadCardTypeSelect();
        } else {
          this.titlechoose = 'Chọn ngân hàng';
          this.showTypeSelect = false;
          this.code = null;
          this.serial = null;
        }
        if (this.havebankid === false) {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(this.banksoption), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var bankshow = _step6.value;

              if (typeid === bankshow.type_id) {
                this.banksfilter = this.banksfilter.concat(bankshow);
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }

          this.bank_key = this.banksfilter[0]['key'];
          this.listbankchannel(this.bank_key);
        } else {
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = get_iterator_default()(this.banksoption), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _bankshow = _step7.value;

              if (typeid === _bankshow.type_id && this.bank_key === _bankshow.key) {
                this.banksfilter = this.banksfilter.concat(_bankshow);
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
        this.showBank = true;
        this.showChannel = true;
      }
    },
    listbankchannel: function listbankchannel(bankkey) {
      this.showChannel = false;
      this.channel_key = null;
      this.channelsfilter = [];
      this.channelmin = null;
      this.channelmax = null;
      this.needBank = null;
      this.need_scratchcard = null;
      this.need_name = false;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(this.channels), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var bankchannelshow = _step8.value;

          if (bankchannelshow.type_id === this.typeid && bankchannelshow.related_bankid === bankkey) {
            this.channelsfilter = this.channelsfilter.concat(bankchannelshow);
            if (bankchannelshow.default_show) {
              this.channel_key = bankchannelshow.key;
              this.channelmin = bankchannelshow.min_load;
              this.channelmax = bankchannelshow.max_load;
              this.needBank = bankchannelshow.need_bank;
              this.channeldesc = bankchannelshow.description;
              this.need_scratchcard = bankchannelshow.need_scratchcard;
              this.need_name = bankchannelshow.need_name;
            } else {
              this.channel_key = this.channelsfilter[0]['key'];
              this.channelmin = this.channelsfilter[0]['min_load'];
              this.channelmax = this.channelsfilter[0]['max_load'];
              this.needBank = this.channelsfilter[0]['need_bank'];
              this.channeldesc = this.channelsfilter[0]['description'];
              this.need_scratchcard = this.channelsfilter[0]['need_scratchcard'];
              this.need_name = this.channelsfilter[0]['need_name'];
            }
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      if (bankkey !== null) {
        this.showChannel = true;
      }
    },
    channelselect: function channelselect(channelkey) {
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = get_iterator_default()(this.channels), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var selectchannel = _step9.value;

          if (this.bank_key === null) {
            if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key) {
              this.channelmin = selectchannel.min_load;
              this.channelmax = selectchannel.max_load;
              this.needBank = selectchannel.need_bank;
              this.channeldesc = selectchannel.description;
              this.need_scratchcard = selectchannel.need_scratchcard;
              this.need_name = selectchannel.need_name;
            }
          } else {
            if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key && this.bank_key === selectchannel.related_bankid) {
              this.channelmin = selectchannel.min_load;
              this.channelmax = selectchannel.max_load;
              this.needBank = selectchannel.need_bank;
              this.channeldesc = selectchannel.description;
              this.need_scratchcard = selectchannel.need_scratchcard;
              this.need_name = selectchannel.need_name;
              this.handleLoadCardTypeSelect();
            }
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    },
    check: function check() {
      this.$vux.loading.show({
        text: 'Loading'
      });
      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.channelmin;
      var maxLoad = this.channelmax;
      if (this.bank_key === null && (this.typeid === 12 || this.typeid === 13)) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng chọn ngân hàng！',
          'type': 'warn'
        });
        return;
      }

      if (this.bank_key === null && this.typeid === 14) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng chọn loại thẻ！',
          'type': 'warn'
        });
        return;
      }
      if (this.showTypeSelect === true && (this.code === null || this.code.trim() === '' || this.serial === null || this.serial.trim() === '')) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng nhập Mã thẻ và số seri！',
          'type': 'warn'
        });
        return;
      }

      if (this.need_name && this.name === '') {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng nhập tên thật！',
          'type': 'warn'
        });
        return;
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        this.submit(submitAmout);
      } else {
        this.$vux.loading.hide();
        this.$vux.alert.show({
          content: 'Hỗ trợ nạp tiền ' + minLoad + 'VND ~ ' + maxLoad + ' VND '
        });
      }
    },
    generalDepositCreateParams: function generalDepositCreateParams(amount) {
      var self = this;
      return {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.channel_key,
        bank_id: self.bank_key,
        name: self.name,
        amount: amount,
        bank_card_no: self.bank_card_no
      };
    },
    vinaPhoneCardDepositCreateParams: function vinaPhoneCardDepositCreateParams(amount) {
      var self = this;
      return {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.channel_key,
        bank_id: self.bank_key,
        name: self.name,
        amount: amount,
        serial: self.serial,
        code: self.code,
        type: self.bank_key
      };
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;
      var params = this.need_scratchcard ? this.vinaPhoneCardDepositCreateParams(submitAmout) : this.generalDepositCreateParams(submitAmout);

      self.$models.Deposit.create(params).then(function (response) {
        self.pay_click = false;
        if (!response.data.success) {
          self.$vux.loading.hide();
          self.$router.replace({
            path: '/error',
            query: {
              title: response.data.message,
              description1: 'Đặt hàng：' + self.app_order_no,
              description2: 'Kênh số：#' + self.channel_key,
              description3: ''
            }
          });
          return;
        }
        cookie["a" /* default */].remove('historys');
        self.load_url = response.data.data.load_url;
        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          return;
        } else if (response.data.data.load_straight === 2) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url,
              deposit_type: response.data.data.deposit_type,
              platform_id: self.channel_key,
              from_url: self.$route.path
            }
          });
          return;
        }
        if (self.need_scratchcard && self.typeid === 14) {
          self.$router.replace({ path: '/finished' });
          return;
        }

        self.showPayPage = true;
        setTimeout(function () {
          self.$vux.loading.hide();
        }, 2000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: 'Vui lòng hoàn tất thanh toán trong cửa sổ mở mới<br />Nếu đã hoàn tất, hãy nhấp vào "hoàn tất thanh toán"',
        confirmText: 'Hoàn tất thanh toán',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: 'Đơn đặt hàng được bắt đầu quá thường xuyên',
              description1: 'Xin lỗi vì bạn thường xuyên đặt hàng nhưng không gửi thanh toán',
              description2: 'Xin vui lòng mất năm phút nghỉ để thử lại, cảm ơn bạn đã hợp tác của bạn'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
        console.log(historys);
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },

    numberWithCommas: numberWithCommas,
    handleLoadCardTypeSelect: function handleLoadCardTypeSelect() {
      this.code = null;
      this.serial = null;
      this.showTypeSelect = this.typeid === 14 && this.need_scratchcard === 1;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7076474c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Deposit.vue
var Deposit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-add cssoverwrite",staticStyle:{"height":"100%"}},[(_vm.videooff)?_c('div',{staticClass:"helpicon",on:{"click":_vm.helpcenter}},[_c('img',{attrs:{"src":"static/images/helpcenter/help-center-icon.png"}})]):_vm._e(),_vm._v(" "),(_vm.videooff)?_c('div',[_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"51px"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":"Nạp Tiền","left-options":{showBack: false, backText: ''},"right-options":{showMore: false}},slot:"header"}),_vm._v(" "),_c('template',{slot:"default"},[_c('group',{attrs:{"gutter":"10px","title":'Đặt hàng：' + _vm.app_order_no}},[_c('group',{attrs:{"gutter":"0px"}},[_c('div',{staticClass:"typetitle"},[_vm._v("Phương thức thanh toán")]),_vm._v(" "),_c('div',{staticClass:"typecon"},[_c('radio',{attrs:{"options":_vm.typeoption},on:{"on-change":_vm.listChannel},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('div',{staticClass:"type-icon"},[_c('img',{attrs:{"width":"38","src":props.icon}})]),_vm._v(" "),_c('div',{staticClass:"type-label"},[_vm._v(_vm._s(props.label))]),_vm._v(" "),( _vm.typeoption[props.index].isfeatured)?_c('div',{staticClass:"featuredtype"},[_c('img',{attrs:{"src":"static/images/ui/deposit/reco-mobile.png","alt":""}})]):_vm._e()]}}],null,false,2571710570),model:{value:(_vm.typeid),callback:function ($$v) {_vm.typeid=$$v},expression:"typeid"}})],1)]),_vm._v(" "),(_vm.showBank)?_c('group',{staticClass:"bankdisplay",attrs:{"gutter":"0px"}},[_c('div',{staticClass:"banktitle"},[_vm._v(_vm._s(_vm.titlechoose))]),_vm._v(" "),_c('radio',{attrs:{"options":_vm.banksfilter},on:{"on-change":_vm.listbankchannel},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"line-height":"40px","display":"table"}},[_c('span',{staticStyle:{"display":"table-cell","vertical-align":"middle"}},[_c('img',{staticClass:"rmargin-20px",staticStyle:{"margin-right":"10px","vertical-align":"middle"},attrs:{"width":"40","src":props.icon}})]),_vm._v(" "),_c('span',{staticStyle:{"display":"table-cell","line-height":"18px","vertical-align":"middle","font-size":"15px"}},[_vm._v(_vm._s(props.label))])])]}}],null,false,1198964437),model:{value:(_vm.bank_key),callback:function ($$v) {_vm.bank_key=$$v},expression:"bank_key"}})],1):_vm._e(),_vm._v(" "),(_vm.showChannel)?_c('group',{attrs:{"gutter":"0px"}},[_c('div',{staticClass:"channeltitle"},[_vm._v("Chọn kênh")]),_vm._v(" "),_c('div',{staticClass:"channelcon"},[_c('radio',{attrs:{"options":_vm.channelsfilter},on:{"on-change":_vm.channelselect},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('div',{staticClass:"channel-icon"},[_c('img',{attrs:{"width":"40","src":props.icon}})]),_vm._v(" "),_c('div',{staticClass:"channel-label"},[_c('div',{staticClass:"labelchannel"},[_vm._v(_vm._s(props.label))]),_vm._v(" "),_c('div',{staticClass:"channelrange"},[_vm._v(_vm._s(_vm.numberWithCommas(_vm.channelsfilter[props.index].min_load))+"-"+_vm._s(_vm.numberWithCommas(_vm.channelsfilter[props.index].max_load))+" VND\n                  ")])]),_vm._v(" "),_c('div')]}}],null,false,2445559336),model:{value:(_vm.channel_key),callback:function ($$v) {_vm.channel_key=$$v},expression:"channel_key"}})],1)]):_vm._e(),_vm._v(" "),(_vm.showTypeSelect)?_c('div',{staticClass:"vinacon"},[_c('group',{attrs:{"gutter":"0"}},[_c('x-input',{staticClass:"x-input-default",attrs:{"type":"text","placeholder":"Mã thẻ","text-align":"left"},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}),_vm._v(" "),_c('x-input',{staticClass:"x-input-default",attrs:{"type":"text","placeholder":"Số seri","text-align":"left"},model:{value:(_vm.serial),callback:function ($$v) {_vm.serial=$$v},expression:"serial"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.need_name)?_c('x-input',{staticClass:"x-input-default",attrs:{"title":"tên người trả tiền","type":"text"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}):_vm._e(),_vm._v(" "),(_vm.showAmountInput)?_c('div',[_c('group',{attrs:{"gutter":"0","title":'Tối thiểu ' + _vm.channelmin + ' VND Cao nhất ' + _vm.channelmax + ' VND'}},[(_vm.show_amount_input)?_c('x-input',{attrs:{"title":_vm.input_amount * 1 + ' Tách rời',"type":"tel","placeholder":"Nhập một khoản tiền tùy chỉnh","text-align":"right","max":9},model:{value:(_vm.input_amount),callback:function ($$v) {_vm.input_amount=$$v},expression:"input_amount"}}):_vm._e()],1)],1):_c('x-input',{attrs:{"title":"Số tiền thanh toán：","disabled":true,"value":_vm.numberWithCommas(_vm.show_amount)}}),_vm._v(" "),_c('box',{attrs:{"gap":"50px 15px 15px 15px"}},[_c('div',{staticStyle:{"font-size":"0.8em","padding":"15px 30px","text-align":"left"}},[_c('p',[_c('i',[_vm._v(_vm._s(_vm.channeldesc))])])]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary","disabled":_vm.pay_click},nativeOn:{"click":function($event){return _vm.check.apply(null, arguments)}}},[_vm._v("Thanh toán ngay")])],1)],1),_vm._v(" "),(_vm.orientpos && _vm.rotate)?_c('div',{staticClass:"verticalcheck"},[_c('div',{staticClass:"verticalnotif"},[_c('div',{staticClass:"closeit",on:{"click":_vm.closeIt}},[_vm._v("×")]),_vm._v(" "),_c('img',{attrs:{"src":"static/images/vertical.gif","alt":"","width":"100px"}}),_vm._v("\n          Để có trải nghiệm tốt hơn, hãy xoay màn hình của bạn theo chiều dọc (hướng dọc)\n        ")])]):_vm._e(),_vm._v(" "),_c('popup',{attrs:{"height":"100%"},on:{"on-hide":_vm.showAsk},model:{value:(_vm.showPayPage),callback:function ($$v) {_vm.showPayPage=$$v},expression:"showPayPage"}},[_c('view-box',{staticStyle:{"height":"100%"},attrs:{"slot":"default","body-padding-top":"50px","body-padding-bottom":"0"},slot:"default"},[_c('x-button',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100","border-radius":"0","height":"58px"},attrs:{"slot":"header","text":"完成","type":"primary"},nativeOn:{"click":function($event){_vm.showPayPage = false}},slot:"header"}),_vm._v(" "),(_vm.showPayPage)?_c('iframe',{staticStyle:{"position":"absolute","border":"none","top":"50px"},attrs:{"src":_vm.load_url,"width":"100%","height":"100%"}}):_vm._e()],1)],1),_vm._v(" "),_c('p',{staticClass:"copy-right"},[_vm._v("© PayNow")])],1)],2)],1):_vm._e(),_vm._v(" "),(_vm.videoon)?_c('div',{staticClass:"videoPage"},[_c('div',{staticClass:"backicon",on:{"click":_vm.backtomain}},[_c('img',{attrs:{"src":"static/images/helpcenter/back-icon.png"}})]),_vm._v(" "),_c('div',{staticClass:"videoheader"},[_vm._v("TRUNG TÂM TRỢ GIÚP")]),_vm._v(" "),_c('div',{staticClass:"videocon"},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.viewvideo('banktransfer')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-bank.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('onlinebank')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-onlinebank.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('momo')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-momo.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('viettel')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-viettel.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('zalo')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-zalo.jpg"}})])])]),_vm._v(" "),(_vm.popvid)?_c('div',{staticClass:"videobg"},[_c('div',{staticClass:"videoplayercon"},[_c('video',{attrs:{"src":"","id":"videoinfo","controls":""}}),_vm._v(" "),_c('div',{staticClass:"closebtn",on:{"click":_vm.closevid}},[_c('img',{attrs:{"src":"static/images/helpcenter/closebtn.png"}})])])]):_vm._e()]):_vm._e()])}
var Deposit_staticRenderFns = []
var Deposit_esExports = { render: Deposit_render, staticRenderFns: Deposit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Deposit = (Deposit_esExports);
// CONCATENATED MODULE: ./src/components/Deposit.vue
var Deposit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Deposit___vue_template_functional__ = false
/* styles */
var Deposit___vue_styles__ = null
/* scopeId */
var Deposit___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Deposit___vue_module_identifier__ = null
var Deposit_Component = Deposit_normalizeComponent(
  components_Deposit,
  selectortype_template_index_0_src_components_Deposit,
  Deposit___vue_template_functional__,
  Deposit___vue_styles__,
  Deposit___vue_scopeId__,
  Deposit___vue_module_identifier__
)

/* harmony default export */ var src_components_Deposit = (Deposit_Component.exports);

// EXTERNAL MODULE: ./node_modules/qr.js/lib/QRCode.js
var QRCode = __webpack_require__("0k+n");
var QRCode_default = /*#__PURE__*/__webpack_require__.n(QRCode);

// EXTERNAL MODULE: ./node_modules/qr.js/lib/ErrorCorrectLevel.js
var ErrorCorrectLevel = __webpack_require__("LpmL");
var ErrorCorrectLevel_default = /*#__PURE__*/__webpack_require__.n(ErrorCorrectLevel);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/qrcode/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_qrcode = ({
  name: 'qrcode',
  props: {
    value: String,
    size: {
      type: Number,
      default: 160
    },
    level: {
      type: String,
      default: 'L'
    },
    bgColor: {
      type: String,
      default: '#FFFFFF'
    },
    fgColor: {
      type: String,
      default: '#000000'
    },
    type: {
      type: String,
      default: 'img'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },
  data: function data() {
    return {
      imgData: ''
    };
  },

  watch: {
    value: function value() {
      this.render();
    },
    size: function size() {
      this.render();
    },
    level: function level() {
      this.render();
    },
    bgColor: function bgColor() {
      this.render();
    },
    fgColor: function fgColor() {
      this.render();
    }
  },
  methods: {
    render: function render() {
      var _this2 = this;

      if (typeof this.value === 'undefined') {
        return;
      }

      var qrcode = new QRCode_default.a(-1, ErrorCorrectLevel_default.a[this.level]);
      qrcode.addData(utf16to8(this.value));
      qrcode.make();

      var canvas = this.$refs.canvas;

      var ctx = canvas.getContext('2d');
      var cells = qrcode.modules;
      var tileW = this.size / cells.length;
      var tileH = this.size / cells.length;
      var scale = (window.devicePixelRatio || 1) / getBackingStorePixelRatio(ctx);
      canvas.height = canvas.width = this.size * scale;
      ctx.scale(scale, scale);

      cells.forEach(function (row, rdx) {
        row.forEach(function (cell, cdx) {
          ctx.fillStyle = cell ? _this2.fgColor : _this2.bgColor;
          var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
          var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
          ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
        });
      });
      if (this.type === 'img') {
        this.imgData = canvas.toDataURL('image/png');
      }
    }
  }
});

function getBackingStorePixelRatio(ctx) {
  return ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
}

function utf16to8(str) {
  var out, i, len, c;
  out = '';
  len = str.length;
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x0001 && c <= 0x007F) {
      out += str.charAt(i);
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | c >> 12 & 0x0F);
      out += String.fromCharCode(0x80 | c >> 6 & 0x3F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    } else {
      out += String.fromCharCode(0xC0 | c >> 6 & 0x1F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    }
  }
  return out;
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/qrcode/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_qrcode = ({
  name: 'qrcode',
  props: {
    value: String,
    size: {
      type: Number,
      default: 160
    },
    level: {
      type: String,
      default: 'L'
    },
    bgColor: {
      type: String,
      default: '#FFFFFF'
    },
    fgColor: {
      type: String,
      default: '#000000'
    },
    type: {
      type: String,
      default: 'img'
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.render();
    });
  },
  data: function data() {
    return {
      imgData: ''
    };
  },

  watch: {
    value: function value() {
      this.render();
    },
    size: function size() {
      this.render();
    },
    level: function level() {
      this.render();
    },
    bgColor: function bgColor() {
      this.render();
    },
    fgColor: function fgColor() {
      this.render();
    }
  },
  methods: {
    render: function render() {
      var _this2 = this;

      if (typeof this.value === 'undefined') {
        return;
      }

      var qrcode = new QRCode_default.a(-1, ErrorCorrectLevel_default.a[this.level]);
      qrcode.addData(qrcode_utf16to8(this.value));
      qrcode.make();

      var canvas = this.$refs.canvas;

      var ctx = canvas.getContext('2d');
      var cells = qrcode.modules;
      var tileW = this.size / cells.length;
      var tileH = this.size / cells.length;
      var scale = (window.devicePixelRatio || 1) / qrcode_getBackingStorePixelRatio(ctx);
      canvas.height = canvas.width = this.size * scale;
      ctx.scale(scale, scale);

      cells.forEach(function (row, rdx) {
        row.forEach(function (cell, cdx) {
          ctx.fillStyle = cell ? _this2.fgColor : _this2.bgColor;
          var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
          var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
          ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
        });
      });
      if (this.type === 'img') {
        this.imgData = canvas.toDataURL('image/png');
      }
    }
  }
});

function qrcode_getBackingStorePixelRatio(ctx) {
  return ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1;
}

function qrcode_utf16to8(str) {
  var out, i, len, c;
  out = '';
  len = str.length;
  for (i = 0; i < len; i++) {
    c = str.charCodeAt(i);
    if (c >= 0x0001 && c <= 0x007F) {
      out += str.charAt(i);
    } else if (c > 0x07FF) {
      out += String.fromCharCode(0xE0 | c >> 12 & 0x0F);
      out += String.fromCharCode(0x80 | c >> 6 & 0x3F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    } else {
      out += String.fromCharCode(0xC0 | c >> 6 & 0x1F);
      out += String.fromCharCode(0x80 | c >> 0 & 0x3F);
    }
  }
  return out;
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a0c502d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/qrcode/index.vue
var qrcode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.type === 'canvas'),expression:"type === 'canvas'"}],ref:"canvas",style:({
    height: (_vm.size + "px"),
    width: (_vm.size + "px")
  }),attrs:{"height":_vm.size,"width":_vm.size}}),_vm._v(" "),(_vm.type === 'img')?_c('img',{style:({
    height: (_vm.size + "px"),
    width: (_vm.size + "px")
  }),attrs:{"src":_vm.imgData}}):_vm._e()])}
var qrcode_staticRenderFns = []
var qrcode_esExports = { render: qrcode_render, staticRenderFns: qrcode_staticRenderFns }
/* harmony default export */ var vux_src_components_qrcode = (qrcode_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/qrcode/index.vue
var qrcode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var qrcode___vue_template_functional__ = false
/* styles */
var qrcode___vue_styles__ = null
/* scopeId */
var qrcode___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var qrcode___vue_module_identifier__ = null
var qrcode_Component = qrcode_normalizeComponent(
  src_components_qrcode,
  vux_src_components_qrcode,
  qrcode___vue_template_functional__,
  qrcode___vue_styles__,
  qrcode___vue_scopeId__,
  qrcode___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_qrcode = (qrcode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Qrcode.vue







/* harmony default export */ var Qrcode = ({
  data: function data() {
    return {
      qrcode: '',
      deposit_type: '',
      totalTime: 90,
      content: '90',
      platform_id: null
    };
  },
  mounted: function mounted() {
    var self = this;
    self.qrcode = self.$router.currentRoute.query.qrcode;
    self.platform_id = self.$router.currentRoute.query.platform_id;
    self.deposit_type = self.$router.currentRoute.query.deposit_type;
    this.countDown();
  },

  components: {
    Qrcode: node_modules_vux_src_components_qrcode,
    XHeader: vux_src_components_x_header,
    Box: vux_src_components_box,
    XButton: vux_src_components_x_button,
    ViewBox: vux_src_components_view_box
  },
  methods: {
    clickBack: function clickBack() {
      var self = this;
      self.$router.replace({
        path: self.$router.currentRoute.query.from_url
      });
    },
    countDown: function countDown() {
      var _this = this;

      var clock = window.setInterval(function () {
        _this.totalTime--;
        _this.content = _this.totalTime;
        if (_this.totalTime < 1) {
          // 当倒计时小于0时清除定时器
          window.clearInterval(clock);
        }
      }, 1000);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Qrcode.vue







/* harmony default export */ var components_Qrcode = ({
  data: function data() {
    return {
      qrcode: '',
      deposit_type: '',
      totalTime: 90,
      content: '90',
      platform_id: null
    };
  },
  mounted: function mounted() {
    var self = this;
    self.qrcode = self.$router.currentRoute.query.qrcode;
    self.platform_id = self.$router.currentRoute.query.platform_id;
    self.deposit_type = self.$router.currentRoute.query.deposit_type;
    this.countDown();
  },

  components: {
    Qrcode: node_modules_vux_src_components_qrcode,
    XHeader: vux_src_components_x_header,
    Box: vux_src_components_box,
    XButton: vux_src_components_x_button,
    ViewBox: vux_src_components_view_box
  },
  methods: {
    clickBack: function clickBack() {
      var self = this;
      self.$router.replace({
        path: self.$router.currentRoute.query.from_url
      });
    },
    countDown: function countDown() {
      var _this = this;

      var clock = window.setInterval(function () {
        _this.totalTime--;
        _this.content = _this.totalTime;
        if (_this.totalTime < 1) {
          // 当倒计时小于0时清除定时器
          window.clearInterval(clock);
        }
      }, 1000);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-421d8c4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Qrcode.vue
var Qrcode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-qrcode",staticStyle:{"height":"100%"}},[_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"51px"}},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":"充值","left-options":{backText: '', preventGoBack: true}},on:{"on-click-back":function($event){return _vm.clickBack()}},slot:"header"}),_vm._v(" "),_c('template',{slot:"default"},[_c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('qrcode',{attrs:{"value":_vm.qrcode,"type":"img"}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"1em","padding":"40px 30px","text-align":"left"}},[(_vm.platform_id==136 || _vm.platform_id==143)?_c('div',[_c('p',[_vm._v("温馨提示："),_c('br'),_vm._v("\n\t              1、使用A手机在打开页面获取二维码；"),_c('br'),_vm._v("\n\t              2、使用B手机的微信完成扫码支付；"),_c('br'),_vm._v("\n\t              3、建议直接保存二维码到相册，打开本机微信扫码功能，从相册选择二维码，识别进行支付。"),_c('br')])]):_vm._e(),_vm._v(" "),(_vm.platform_id==21)?_c('div',[_c('p',[_vm._v("温馨提示："),_c('br'),_vm._v("\n\t              1、在打开页面截屏保存二维码；"),_c('br'),_vm._v("\n\t              2、使用QQ扫一扫，获取刚才您保存的二维码；"),_c('br'),_vm._v("\n\t              3、进入QQ钱包完成支付。"),_c('br')])]):_vm._e(),_vm._v(" "),(_vm.deposit_type==1 || _vm.platform_id==147 || _vm.platform_id==259)?_c('div',[_c('p',[_vm._v("温馨提示："),_c('br'),_vm._v("\n              1、请截屏保存二维码；"),_c('br'),_vm._v("\n              2、使用银联官方APP：云闪付扫码，同时支持任何一家银行、大众点评、京东、美团APP扫码即可完成支付；\n            ")])]):_vm._e(),_vm._v(" "),(_vm.platform_id==89)?_c('div',[_c('p',[_vm._v("温馨提示："),_c('br'),_vm._v("\n              1、在打开页面截屏保存二维码；"),_c('br'),_vm._v("\n              2、使用支付宝扫一扫，获取刚才您保存的二维码；"),_c('br'),_vm._v("\n              3、进入支付宝完成支付。"),_c('br'),_vm._v("\n              4、请在"),_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.content))]),_vm._v("秒内完成支付。"),_c('br')])]):_vm._e()])],1)])],2)],1)}
var Qrcode_staticRenderFns = []
var Qrcode_esExports = { render: Qrcode_render, staticRenderFns: Qrcode_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Qrcode = (Qrcode_esExports);
// CONCATENATED MODULE: ./src/components/Qrcode.vue
function Qrcode_injectStyle (ssrContext) {
  __webpack_require__("PwJU")
}
var Qrcode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Qrcode___vue_template_functional__ = false
/* styles */
var Qrcode___vue_styles__ = Qrcode_injectStyle
/* scopeId */
var Qrcode___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Qrcode___vue_module_identifier__ = null
var Qrcode_Component = Qrcode_normalizeComponent(
  components_Qrcode,
  selectortype_template_index_0_src_components_Qrcode,
  Qrcode___vue_template_functional__,
  Qrcode___vue_styles__,
  Qrcode___vue_scopeId__,
  Qrcode___vue_module_identifier__
)

/* harmony default export */ var src_components_Qrcode = (Qrcode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/msg/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var msg = ({
  name: 'msg',
  props: ['icon', 'title', 'description', 'buttons'],
  methods: {
    onClick: function onClick(handler, link) {
      typeof handler === 'function' && handler();
      link && Object(router["a" /* go */])(link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/msg/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_msg = ({
  name: 'msg',
  props: ['icon', 'title', 'description', 'buttons'],
  methods: {
    onClick: function onClick(handler, link) {
      typeof handler === 'function' && handler();
      link && Object(router["a" /* go */])(link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fb41afc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/msg/index.vue
var msg_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-msg"},[_c('div',{staticClass:"weui-msg__icon-area"},[_c('i',{staticClass:"weui-icon_msg",class:("weui-icon-" + (_vm.icon || 'success'))})]),_vm._v(" "),_c('div',{staticClass:"weui-msg__text-area"},[_c('h2',{staticClass:"weui-msg__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-msg__desc"},[_vm._t("description")],2),_vm._v(" "),(_vm.description)?_c('p',{staticClass:"weui-msg__desc",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-msg__opr-area"},[_c('p',{staticClass:"weui-btn-area"},[_vm._t("buttons",function(){return _vm._l((_vm.buttons),function(button){return _c('a',{staticClass:"weui-btn",class:("weui-btn_" + (button.type)),attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.onClick(button.onClick, button.link)}}},[_vm._v(_vm._s(button.text))])})})],2)])])}
var msg_staticRenderFns = []
var msg_esExports = { render: msg_render, staticRenderFns: msg_staticRenderFns }
/* harmony default export */ var src_components_msg = (msg_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/msg/index.vue
function msg_injectStyle (ssrContext) {
  __webpack_require__("XHW0")
}
var msg_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var msg___vue_template_functional__ = false
/* styles */
var msg___vue_styles__ = msg_injectStyle
/* scopeId */
var msg___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var msg___vue_module_identifier__ = null
var msg_Component = msg_normalizeComponent(
  components_msg,
  src_components_msg,
  msg___vue_template_functional__,
  msg___vue_styles__,
  msg___vue_scopeId__,
  msg___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_msg = (msg_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Finished.vue



/* harmony default export */ var Finished = ({
  components: {
    Msg: vux_src_components_msg
  },
  data: function data() {
    return {
      title: 'ĐÃ TIẾP NHẬN THẺ CÀO',
      description: 'Đơn nạp đang được xử lý, nếu sau 10 phút vẫn không nhận được hãy liên hệ CSKH'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Finished.vue



/* harmony default export */ var components_Finished = ({
  components: {
    Msg: vux_src_components_msg
  },
  data: function data() {
    return {
      title: 'ĐÃ TIẾP NHẬN THẺ CÀO',
      description: 'Đơn nạp đang được xử lý, nếu sau 10 phút vẫn không nhận được hãy liên hệ CSKH'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1346a061","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Finished.vue
var Finished_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finished",staticStyle:{"height":"100%"}},[_c('msg',{attrs:{"title":_vm.title,"icon":"success"}},[_c('p',{attrs:{"slot":"description"},slot:"description"},[_c('span',[_vm._v(_vm._s(_vm.description))])])])],1)}
var Finished_staticRenderFns = []
var Finished_esExports = { render: Finished_render, staticRenderFns: Finished_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Finished = (Finished_esExports);
// CONCATENATED MODULE: ./src/components/Finished.vue
var Finished_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Finished___vue_template_functional__ = false
/* styles */
var Finished___vue_styles__ = null
/* scopeId */
var Finished___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Finished___vue_module_identifier__ = null
var Finished_Component = Finished_normalizeComponent(
  components_Finished,
  selectortype_template_index_0_src_components_Finished,
  Finished___vue_template_functional__,
  Finished___vue_styles__,
  Finished___vue_scopeId__,
  Finished___vue_module_identifier__
)

/* harmony default export */ var src_components_Finished = (Finished_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Error.vue



/* harmony default export */ var Error = ({
  components: {
    Msg: vux_src_components_msg
  },
  data: function data() {
    return {
      prev: '',
      title: '未知错误',
      description1: '',
      description2: '',
      description3: '',
      description4: '',
      description5: ''
    };
  },
  mounted: function mounted() {
    if (typeof this.$route.query.title === 'string') {
      this.title = this.$route.query.title;
    }
    if (typeof this.$route.query.description1 === 'string') {
      this.description1 = this.$route.query.description1;
    }
    if (typeof this.$route.query.description2 === 'string') {
      this.description2 = this.$route.query.description2;
    }
    if (typeof this.$route.query.description3 === 'string') {
      this.description3 = this.$route.query.description3;
    }
    if (typeof this.$route.query.description4 === 'string') {
      this.description4 = this.$route.query.description4;
    }
    if (typeof this.$route.query.description5 === 'string') {
      this.description5 = this.$route.query.description5;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Error.vue



/* harmony default export */ var components_Error = ({
  components: {
    Msg: vux_src_components_msg
  },
  data: function data() {
    return {
      prev: '',
      title: '未知错误',
      description1: '',
      description2: '',
      description3: '',
      description4: '',
      description5: ''
    };
  },
  mounted: function mounted() {
    if (typeof this.$route.query.title === 'string') {
      this.title = this.$route.query.title;
    }
    if (typeof this.$route.query.description1 === 'string') {
      this.description1 = this.$route.query.description1;
    }
    if (typeof this.$route.query.description2 === 'string') {
      this.description2 = this.$route.query.description2;
    }
    if (typeof this.$route.query.description3 === 'string') {
      this.description3 = this.$route.query.description3;
    }
    if (typeof this.$route.query.description4 === 'string') {
      this.description4 = this.$route.query.description4;
    }
    if (typeof this.$route.query.description5 === 'string') {
      this.description5 = this.$route.query.description5;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2c70da6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Error.vue
var Error_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finished",staticStyle:{"height":"100%"}},[_c('msg',{attrs:{"title":_vm.title,"icon":"warn"}},[_c('p',{attrs:{"slot":"description"},slot:"description"},[_c('span',[_vm._v(_vm._s(_vm.description1))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.description2))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.description3))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.description4))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.description5))]),_c('br')])])],1)}
var Error_staticRenderFns = []
var Error_esExports = { render: Error_render, staticRenderFns: Error_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Error = (Error_esExports);
// CONCATENATED MODULE: ./src/components/Error.vue
var Error_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Error___vue_template_functional__ = false
/* styles */
var Error___vue_styles__ = null
/* scopeId */
var Error___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Error___vue_module_identifier__ = null
var Error_Component = Error_normalizeComponent(
  components_Error,
  selectortype_template_index_0_src_components_Error,
  Error___vue_template_functional__,
  Error___vue_styles__,
  Error___vue_scopeId__,
  Error___vue_module_identifier__
)

/* harmony default export */ var src_components_Error = (Error_Component.exports);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BankDetails.vue













/* harmony default export */ var BankDetails = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio
  },
  beforeCreate: function beforeCreate() {
    document.body.className = 'charge';
  },
  data: function data() {
    return {
      bdorderNum: '',
      bdamount: '',
      bdactname: '',
      bdactnum: '',
      bdbankimgsrc: '',
      bdqrimgsrc: '',
      bdbankname: '',
      qrimage: false,
      bankimg: true
    };
  },
  mounted: function mounted() {
    var self = this;
    self.getorderno();
  },

  methods: {
    copyText: function copyText(idtext) {
      var textToCopy = document.getElementById(idtext);
      var self = this;
      var range;
      if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(textToCopy);
        range.select();
        document.execCommand('Copy');
        self.$vux.toast.show({
          'text': 'Sao chép！',
          'type': 'success'
        });
      } else if (window.getSelection) {

        var selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(textToCopy);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('Copy');
        self.$vux.toast.show({
          'text': 'Sao chép！',
          'type': 'success'
        });
      }
    },
    getorderno: function getorderno() {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var getparams = urlParams.get('order_no');
      var bdbankdetails = {
        115: { name: 'Techcombank', sign: 'TCB' },
        116: { name: 'Sacombank', sign: 'SAC' },
        117: { name: 'Vietcombank', sign: 'VCB' },
        118: { name: 'Asia Commercial Bank', sign: 'ACB' },
        119: { name: 'DongA Bank', sign: 'DAB' },
        120: { name: 'Vietin Bank', sign: 'VTB' },
        121: { name: 'Bank for Investment and Development of Vietnam', sign: 'BIDV' },
        122: { name: 'Eximbank Vietnam', sign: 'EXB' },
        123: { name: 'Bank Central Asia', sign: 'BCA' },
        124: { name: 'Bank Negara Indonesia', sign: 'BNI' },
        125: { name: 'Bank Rakyat Indonesia', sign: 'BRI' },
        126: { name: 'Mandiri Bank', sign: 'MDR' },
        127: { name: 'CIMB Niaga', sign: 'CIMBN' },
        128: { name: 'Vietnam Prosperity Joint-Stock Commercial Bank', sign: 'VP' },
        129: { name: 'Military Commercial Joint Stock Bank', sign: 'MB' },
        130: { name: 'Tien Phong Commercial', sign: 'TPB' },
        131: { name: 'AGRI BANK', sign: 'AGRI' },
        132: { name: 'Lien Viet Post Joint Stock Commercial Bank', sign: 'LienVietPostBank' },
        133: { name: 'Saigon – Hanoi Commercial Joint Stock Bank', sign: 'SHB' },
        134: { name: 'Vietnam Public Joint-stock Commercial Bank', sign: 'PVcombank' },
        1000: { name: 'Others Bank', sign: 'OTHERS' }
      };
      console.log(getparams);
      var self = this;
      if (getparams !== null) {
        axios_default()({
          url: 'https://payvndnow.com/api/deposit/pay?order_no=' + getparams,
          headers: {
            'Content-type': 'application/x-www-form-urlencoded'
          },
          method: 'post'
        }).then(function (response) {

          if (response.data.success === 1) {
            var bankid = response.data.data.bank_id;
            self.bdorderNum = response.data.data.order_no;
            self.bdamount = response.data.data.amount;
            self.bdactname = response.data.data.account_name;
            self.bdactnum = response.data.data.account_no;
            self.bdbankimgsrc = 'static/images/vnbanks/' + bdbankdetails[bankid]['sign'] + '.png';
            self.bdqrimgsrc = response.data.data.QR_code;
            self.bdbankname = bdbankdetails[bankid]['name'];
            if (self.bdqrimgsrc === '') {
              self.qrimage = false;
            } else {
              self.qrimage = true;
            }
            if (bdbankdetails[bankid]['sign'] === '' || bdbankdetails[bankid]['sign'] === 'OTHERS') {
              self.bankimg = false;
            } else {
              self.bankimg = true;
            }
            console.log(response.data.data.order_no);
          } else {
            self.$vux.toast.show({
              'text': 'kiểm tra số đơn đặt hàng của bạn',
              'type': 'warn'
            });
            self.bankimg = false;
            self.qrimage = false;
            self.bdorderNum = '---';
            self.bdamount = '---';
            self.bdactname = '---';
            self.bdactnum = '---';
            self.bdbankimgsrc = '';
            self.bdqrimgsrc = '';
            self.bdbankname = '---';
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BankDetails.vue













/* harmony default export */ var components_BankDetails = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio
  },
  beforeCreate: function beforeCreate() {
    document.body.className = 'charge';
  },
  data: function data() {
    return {
      bdorderNum: '',
      bdamount: '',
      bdactname: '',
      bdactnum: '',
      bdbankimgsrc: '',
      bdqrimgsrc: '',
      bdbankname: '',
      qrimage: false,
      bankimg: true
    };
  },
  mounted: function mounted() {
    var self = this;
    self.getorderno();
  },

  methods: {
    copyText: function copyText(idtext) {
      var textToCopy = document.getElementById(idtext);
      var self = this;
      var range;
      if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(textToCopy);
        range.select();
        document.execCommand('Copy');
        self.$vux.toast.show({
          'text': 'Sao chép！',
          'type': 'success'
        });
      } else if (window.getSelection) {

        var selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(textToCopy);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('Copy');
        self.$vux.toast.show({
          'text': 'Sao chép！',
          'type': 'success'
        });
      }
    },
    getorderno: function getorderno() {
      var queryString = window.location.search;
      var urlParams = new URLSearchParams(queryString);
      var getparams = urlParams.get('order_no');
      var bdbankdetails = {
        115: { name: 'Techcombank', sign: 'TCB' },
        116: { name: 'Sacombank', sign: 'SAC' },
        117: { name: 'Vietcombank', sign: 'VCB' },
        118: { name: 'Asia Commercial Bank', sign: 'ACB' },
        119: { name: 'DongA Bank', sign: 'DAB' },
        120: { name: 'Vietin Bank', sign: 'VTB' },
        121: { name: 'Bank for Investment and Development of Vietnam', sign: 'BIDV' },
        122: { name: 'Eximbank Vietnam', sign: 'EXB' },
        123: { name: 'Bank Central Asia', sign: 'BCA' },
        124: { name: 'Bank Negara Indonesia', sign: 'BNI' },
        125: { name: 'Bank Rakyat Indonesia', sign: 'BRI' },
        126: { name: 'Mandiri Bank', sign: 'MDR' },
        127: { name: 'CIMB Niaga', sign: 'CIMBN' },
        128: { name: 'Vietnam Prosperity Joint-Stock Commercial Bank', sign: 'VP' },
        129: { name: 'Military Commercial Joint Stock Bank', sign: 'MB' },
        130: { name: 'Tien Phong Commercial', sign: 'TPB' },
        131: { name: 'AGRI BANK', sign: 'AGRI' },
        132: { name: 'Lien Viet Post Joint Stock Commercial Bank', sign: 'LienVietPostBank' },
        133: { name: 'Saigon – Hanoi Commercial Joint Stock Bank', sign: 'SHB' },
        134: { name: 'Vietnam Public Joint-stock Commercial Bank', sign: 'PVcombank' },
        1000: { name: 'Others Bank', sign: 'OTHERS' }
      };
      console.log(getparams);
      var self = this;
      if (getparams !== null) {
        axios_default()({
          url: 'https://payvndnow.com/api/deposit/pay?order_no=' + getparams,
          headers: {
            'Content-type': 'application/x-www-form-urlencoded'
          },
          method: 'post'
        }).then(function (response) {

          if (response.data.success === 1) {
            var bankid = response.data.data.bank_id;
            self.bdorderNum = response.data.data.order_no;
            self.bdamount = response.data.data.amount;
            self.bdactname = response.data.data.account_name;
            self.bdactnum = response.data.data.account_no;
            self.bdbankimgsrc = 'static/images/vnbanks/' + bdbankdetails[bankid]['sign'] + '.png';
            self.bdqrimgsrc = response.data.data.QR_code;
            self.bdbankname = bdbankdetails[bankid]['name'];
            if (self.bdqrimgsrc === '') {
              self.qrimage = false;
            } else {
              self.qrimage = true;
            }
            if (bdbankdetails[bankid]['sign'] === '' || bdbankdetails[bankid]['sign'] === 'OTHERS') {
              self.bankimg = false;
            } else {
              self.bankimg = true;
            }
            console.log(response.data.data.order_no);
          } else {
            self.$vux.toast.show({
              'text': 'kiểm tra số đơn đặt hàng của bạn',
              'type': 'warn'
            });
            self.bankimg = false;
            self.qrimage = false;
            self.bdorderNum = '---';
            self.bdamount = '---';
            self.bdactname = '---';
            self.bdactnum = '---';
            self.bdbankimgsrc = '';
            self.bdqrimgsrc = '';
            self.bdbankname = '---';
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d6f05c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BankDetails.vue
var BankDetails_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bankdetails-con"},[_c('x-header',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100"},attrs:{"slot":"header","title":"Thông tin ngân hàng","left-options":{showBack: false, backText: ''},"right-options":{showMore: false}},slot:"header"}),_vm._v(" "),_c('div',{staticClass:"details-body"},[_c('div',{staticClass:"details-con"},[_c('div',{staticClass:"details-green"},[_c('div',{staticClass:"bd_bg"},[_c('div',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.bankimg),expression:"bankimg"}],attrs:{"src":_vm.bdbankimgsrc}}),_vm._v(" "),_c('div',{staticClass:"bd_amtdetails"},[_c('p',[_vm._v("Chúc mừng bạn")]),_vm._v(" "),_c('span',[_vm._v("Bạn chỉ cần thanh toán")]),_vm._v(" "),_c('div',{staticClass:"bd_amount",attrs:{"id":"copyamt"}},[_vm._v(_vm._s(_vm.bdamount))]),_vm._v(" "),_c('button',{staticClass:"copybtn",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.copyText('copyamt')}}},[_vm._v("Sao chep")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.qrimage),expression:"qrimage"}],staticClass:"bd_qrcode"},[_c('img',{attrs:{"src":_vm.bdqrimgsrc}})])])])]),_vm._v(" "),_c('div',{staticClass:"details-white"},[_c('div',{staticClass:"bd_header"},[_vm._v("Chi tiết tài khoản ngân hàng")]),_vm._v(" "),_c('div',{staticClass:"bd_form"},[_c('div',{staticClass:"bd_orderno"},[_c('span',[_vm._v("Đặt hàng：")]),_vm._v(_vm._s(_vm.bdorderNum))]),_vm._v(" "),_c('div',{staticClass:"bd_bankname"},[_c('div',{staticClass:"bd_label"},[_vm._v("Ngân hàng：")]),_vm._v(" "),_c('div',{staticClass:"bd_name"},[_vm._v(_vm._s(_vm.bdbankname))])]),_vm._v(" "),_c('div',{staticClass:"bd_actname"},[_c('div',{staticClass:"bd_label"},[_vm._v("Ho ten：")]),_vm._v(" "),_c('div',{staticClass:"bd_name",attrs:{"id":"copyname"}},[_vm._v(_vm._s(_vm.bdactname))]),_vm._v(" "),_c('button',{staticClass:"copybtn",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.copyText('copyname')}}},[_vm._v("Sao chep")])]),_vm._v(" "),_c('div',{staticClass:"bd_actno"},[_c('div',{staticClass:"bd_label"},[_vm._v("Tai Khoan：")]),_vm._v(" "),_c('div',{staticClass:"bd_name",attrs:{"id":"copyactno"}},[_vm._v(_vm._s(_vm.bdactnum))]),_vm._v(" "),_c('button',{staticClass:"copybtn",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.copyText('copyactno')}}},[_vm._v("Sao chep")])])])])])]),_vm._v(" "),_c('p',{staticClass:"copy-right"},[_vm._v("© PayNow")])],1)}
var BankDetails_staticRenderFns = []
var BankDetails_esExports = { render: BankDetails_render, staticRenderFns: BankDetails_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_BankDetails = (BankDetails_esExports);
// CONCATENATED MODULE: ./src/components/BankDetails.vue
function BankDetails_injectStyle (ssrContext) {
  __webpack_require__("jLY8")
  __webpack_require__("cV1C")
}
var BankDetails_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BankDetails___vue_template_functional__ = false
/* styles */
var BankDetails___vue_styles__ = BankDetails_injectStyle
/* scopeId */
var BankDetails___vue_scopeId__ = "data-v-3d6f05c4"
/* moduleIdentifier (server only) */
var BankDetails___vue_module_identifier__ = null
var BankDetails_Component = BankDetails_normalizeComponent(
  components_BankDetails,
  selectortype_template_index_0_src_components_BankDetails,
  BankDetails___vue_template_functional__,
  BankDetails___vue_styles__,
  BankDetails___vue_scopeId__,
  BankDetails___vue_module_identifier__
)

/* harmony default export */ var src_components_BankDetails = (BankDetails_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HelpCenter.vue




/* harmony default export */ var HelpCenter = ({
  components: {
    Popup: node_modules_vux_src_components_popup,
    Loading: loading["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    document.body.className = 'charge';
  },
  data: function data() {
    return {
      videoon: false,
      videooff: true,
      popvid: false
    };
  },

  methods: {
    closevid: function closevid() {
      var video = document.getElementById('videoinfo');
      video.removeAttribute('src');
      this.popvid = false;
    },
    viewvideo: function viewvideo(videoname) {
      this.popvid = true;
      setTimeout(function () {
        var video = document.getElementById('videoinfo');
        video.setAttribute('type', 'video/mp4');
        video.setAttribute('src', 'static/images/helpcenter/' + videoname + '.mp4');
        video.load();
        video.play();
      }, 500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HelpCenter.vue




/* harmony default export */ var components_HelpCenter = ({
  components: {
    Popup: node_modules_vux_src_components_popup,
    Loading: loading["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    document.body.className = 'charge';
  },
  data: function data() {
    return {
      videoon: false,
      videooff: true,
      popvid: false
    };
  },

  methods: {
    closevid: function closevid() {
      var video = document.getElementById('videoinfo');
      video.removeAttribute('src');
      this.popvid = false;
    },
    viewvideo: function viewvideo(videoname) {
      this.popvid = true;
      setTimeout(function () {
        var video = document.getElementById('videoinfo');
        video.setAttribute('type', 'video/mp4');
        video.setAttribute('src', 'static/images/helpcenter/' + videoname + '.mp4');
        video.load();
        video.play();
      }, 500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e7f85d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpCenter.vue
var HelpCenter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-add cssoverwrite",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"videoPage"},[_c('div',{staticClass:"videoheader"},[_vm._v("TRUNG TÂM TRỢ GIÚP")]),_vm._v(" "),_c('div',{staticClass:"videocon"},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.viewvideo('banktransfer')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-bank.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('onlinebank')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-onlinebank.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('momo')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-momo.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('viettel')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-viettel.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('zalo')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-zalo.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('viettelpay')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-viettel-pay.jpg"}})])])]),_vm._v(" "),(_vm.popvid)?_c('div',{staticClass:"videobg"},[_c('div',{staticClass:"videoplayercon"},[_c('video',{attrs:{"src":"","id":"videoinfo","controls":""}}),_vm._v(" "),_c('div',{staticClass:"closebtn",on:{"click":_vm.closevid}},[_c('img',{attrs:{"src":"static/images/helpcenter/closebtn.png"}})])])]):_vm._e()])])}
var HelpCenter_staticRenderFns = []
var HelpCenter_esExports = { render: HelpCenter_render, staticRenderFns: HelpCenter_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_HelpCenter = (HelpCenter_esExports);
// CONCATENATED MODULE: ./src/components/HelpCenter.vue
function HelpCenter_injectStyle (ssrContext) {
  __webpack_require__("s4cR")
}
var HelpCenter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var HelpCenter___vue_template_functional__ = false
/* styles */
var HelpCenter___vue_styles__ = HelpCenter_injectStyle
/* scopeId */
var HelpCenter___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var HelpCenter___vue_module_identifier__ = null
var HelpCenter_Component = HelpCenter_normalizeComponent(
  components_HelpCenter,
  selectortype_template_index_0_src_components_HelpCenter,
  HelpCenter___vue_template_functional__,
  HelpCenter___vue_styles__,
  HelpCenter___vue_scopeId__,
  HelpCenter___vue_module_identifier__
)

/* harmony default export */ var src_components_HelpCenter = (HelpCenter_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit2.vue




















/* harmony default export */ var Deposit2 = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Loading: loading["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    document.body.className = 'charge deposit2';
  },
  data: function data() {
    return {
      typeoption: [],
      typeid: null,
      channels: [],
      channelsfilter: [],
      channel_key: null,
      showChannel: false,
      banksoption: [],
      banksfilter: [],
      bank_key: null,
      needBank: null,
      showBank: false,
      havebankid: false,
      titlechoose: 'Chọn ngân hàng',
      channeldesc: '',
      channelmin: null,
      success_rate: null,
      channelmax: null,
      orientpos: false,
      rotate: false,
      query: '',
      title: '充值',
      platform_show: {
        desc: ''
      },
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showTypeSelect: false,
      code: null,
      serial: null,
      need_bank: null,
      need_scratchcard: 0,
      bank_id: null,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      videoon: false,
      videooff: true,
      popvid: false,
      need_name: false
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    this.handleOrientationChange();
    window.addEventListener('orientationchange', this.handleOrientationChange);
    this.checkOrderCounts();
    var self = this;
    self.channel_key = typeof self.$route.query.platform_id === 'undefined' ? 1 : JSON.parse(self.$route.query.platform_id);

    self.$models.Deposit.info({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (typePlatforms) {
      self.checkDepositExists(typePlatforms.data.data);
      self.rotate = typePlatforms.data.data.rotate_prompt;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(typePlatforms.data.data.types), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var typePlatform = _step.value;

          var typelist = {
            key: typePlatform.type_id,
            value: typePlatform.display_name,
            icon: 'static/images/logo/' + typePlatform.icon + '.png',
            isfeatured: typePlatform.is_featured
          };
          var channellist = {};
          if (!isNeedBank(typePlatform.type_id)) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(typePlatform.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var typemobileshow = _step2.value;

                var showmobile, defaultmobile;
                showmobile = typemobileshow.mobile_show;
                defaultmobile = typemobileshow.mobile_default;
                channellist = {
                  show_view: Boolean(showmobile),
                  default_show: Boolean(defaultmobile),
                  key: typemobileshow.id,
                  value: typemobileshow.name,
                  bank_id: typemobileshow.bank_id,
                  banks: typemobileshow.banks,
                  amount_list: typemobileshow.custom_amounts,
                  description: typemobileshow.description,
                  icon: 'static/images/logo/' + typemobileshow.icon + '.png',
                  max_load: typemobileshow.max_load,
                  min_load: typemobileshow.min_load,
                  need_bank: typemobileshow.need_bank,
                  static_amount: typemobileshow.static_amount,
                  type_id: typemobileshow.type_id,
                  need_scratchcard: typemobileshow.need_scratchcard,
                  success_rate: typemobileshow.success_rate,
                  need_name: typemobileshow.need_name
                };
                self.channels = self.channels.concat(channellist);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            self.typeoption = self.typeoption.concat(typelist);
          } else {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = get_iterator_default()(typePlatform.data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _typemobileshow = _step3.value;

                var bankshortname = BANKS[_typemobileshow.icon];
                if (bankshortname === '' || bankshortname === undefined) {
                  bankshortname = _typemobileshow.name;
                }
                var banklist = {
                  key: _typemobileshow.icon,
                  value: bankshortname,
                  icon: 'static/images/vnbanks/icons/' + _typemobileshow.icon + '.png',
                  children: _typemobileshow.children,
                  type_id: typePlatform.type_id
                };
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                  for (var _iterator4 = get_iterator_default()(_typemobileshow.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var typemobileshow2 = _step4.value;

                    showmobile = typemobileshow2.mobile_show;
                    defaultmobile = typemobileshow2.mobile_default;
                    channellist = {
                      show_view: Boolean(showmobile),
                      default_show: Boolean(defaultmobile),
                      key: typemobileshow2.id,
                      value: typemobileshow2.name,
                      bank_id: typemobileshow2.bank_id,
                      banks: typemobileshow2.banks,
                      amount_list: typemobileshow2.custom_amounts,
                      description: typemobileshow2.description,
                      icon: 'static/images/logo/' + typemobileshow2.icon + '.png',
                      max_load: typemobileshow2.max_load,
                      min_load: typemobileshow2.min_load,
                      need_bank: typemobileshow2.need_bank,
                      static_amount: typemobileshow2.static_amount,
                      type_id: typemobileshow2.type_id,
                      related_bankid: _typemobileshow.icon,
                      related_bankname: _typemobileshow.name,
                      need_scratchcard: typemobileshow2.need_scratchcard,
                      success_rate: typemobileshow2.success_rate,
                      need_name: typemobileshow2.need_name
                    };
                    self.channels = self.channels.concat(channellist);
                  }
                } catch (err) {
                  _didIteratorError4 = true;
                  _iteratorError4 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                      _iterator4.return();
                    }
                  } finally {
                    if (_didIteratorError4) {
                      throw _iteratorError4;
                    }
                  }
                }

                self.banksoption = self.banksoption.concat(banklist);
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            self.typeoption = self.typeoption.concat(typelist);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (['', null, '0.00'].includes(typePlatforms.data.data.amount)) {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = typePlatforms.data.data.amount;
      }
      self.app_order_no = typePlatforms.data.data.app_order_no;
      if (self.typeoption.length === 0) {
        self.$router.replace({
          path: '/error',
          query: {
            title: 'Ngân hàng này đang bảo trì.<br />Vui lòng quay lại sau.',
            description1: '\u0110\u1EB7t h\xE0ng\uFF1A' + typePlatforms.data.data.app_order_no,
            description2: 'C\xE1c lo\u1EA1i thanh to\xE1n\uFF1A ' + (typePlatforms.data.data.type === null ? 'Không có kênh nào tại thời gian này' : typePlatforms.data.data.type)
          }
        });
      } else if (self.typeoption.length === 1) {
        self.typeid = self.typeoption[0]['key'];
        if (typePlatforms.data.data.bank_id === null) {
          self.havebankid = false;
          self.listChannel(self.typeid);
          if (!(self.showAmountInput === true || isNeedBank(self.typeid) && self.banksfilter.length > 1 || self.channelsfilter.length > 1)) {
            self.check();
          }
        } else {
          self.havebankid = true;
          self.bank_key = typePlatforms.data.data.bank_id;
          self.listChannel(self.typeid);
          self.listbankchannel(typePlatforms.data.data.bank_id);
          if (!(self.showAmountInput === true || self.channelsfilter.length > 1)) {
            self.check();
          }
        }
      } else if (self.typeoption.length > 1) {
        self.typeid = self.typeoption[0]['key'];
        self.listChannel(self.typeid);
        if (isNeedBank(self.typeid)) {
          self.listbankchannel(self.banksfilter[0]['key']);
          self.bank_key = self.banksfilter[0]['key'];
        }
      }
    });

    sessionStorage.setItem('prev', this.$route.fullPath);
  },

  methods: {
    checkDepositExists: function checkDepositExists(orderInfo) {

      if (orderInfo === undefined || orderInfo === '') {
        this.$router.replace({
          path: '/error',
          query: {
            title: 'Đơn hàng không tồn tại',
            description1: 'Lỗi'
          }
        });
      }

      var hasDeposit = orderInfo.has_deposit,
          appOrderNumber = orderInfo.app_order_no;

      if (hasDeposit) {
        this.$router.replace({
          path: '/error',
          query: {
            title: 'Đơn hàng đã tồn tại',
            description1: '\u0110\u1EB7t h\xE0ng\uFF1A' + appOrderNumber
          }
        });
      }
    },
    handleOrientationChange: function handleOrientationChange() {
      var isRotate = window.screen.orientation && window.screen.orientation.angle > 0 || !window.matchMedia('(orientation: portrait)').matches;

      this.orientpos = /Android|iPhone|iPad|iPod|iOS|BlackBerry|IEMobile/i.test(navigator.userAgent) ? isRotate : false;
    },
    closeIt: function closeIt() {
      this.orientpos = false;
    },
    helpcenter: function helpcenter() {
      this.videoon = true;
      this.videooff = false;
    },
    backtomain: function backtomain() {
      this.videoon = false;
      this.videooff = true;
    },
    closevid: function closevid() {
      var video = document.getElementById('videoinfo');
      video.removeAttribute('src');
      this.popvid = false;
    },
    viewvideo: function viewvideo(videoname) {
      this.popvid = true;
      setTimeout(function () {
        var video = document.getElementById('videoinfo');
        video.setAttribute('type', 'video/mp4');
        video.setAttribute('src', 'static/images/helpcenter/' + videoname + '.mp4');
        video.load();
        video.play();
      }, 500);
    },
    listChannel: function listChannel(typeid) {
      this.typeid = typeid;
      if (!isNeedBank(typeid)) {
        this.showChannel = true;
        this.channel_key = null;
        this.bank_key = null;
        this.channelsfilter = [];
        this.showBank = false;
        this.banksfilter = [];
        this.channelmin = null;
        this.channelmax = null;
        this.success_rate = null;
        this.showTypeSelect = false;
        this.need_scratchcard = null;
        this.need_name = false;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = get_iterator_default()(this.channels), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var channelshow = _step5.value;

            if (typeid === channelshow.type_id) {
              this.channelsfilter = this.channelsfilter.concat(channelshow);
              if (channelshow.default_show) {
                this.channel_key = channelshow.key;
                this.channelmin = channelshow.min_load;
                this.channelmax = channelshow.max_load;
                this.needBank = channelshow.need_bank;
                this.channeldesc = channelshow.description;
                this.need_scratchcard = channelshow.need_scratchcard;
                this.success_rate = channelshow.success_rate;
                this.need_name = channelshow.need_name;
              } else {
                this.channel_key = this.channelsfilter[0]['key'];
                this.channelmin = this.channelsfilter[0]['min_load'];
                this.channelmax = this.channelsfilter[0]['max_load'];
                this.needBank = this.channelsfilter[0]['need_bank'];
                this.channeldesc = this.channelsfilter[0]['description'];
                this.need_scratchcard = this.channelsfilter[0]['need_scratchcard'];
                this.success_rate = this.channelsfilter[0]['success_rate'];
                this.need_name = this.channelsfilter[0]['need_name'];
              }
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      } else {
        this.showBank = false;
        this.banksfilter = [];
        if (typeid === 14) {
          this.titlechoose = 'Chọn loại thẻ';
          this.handleLoadCardTypeSelect();
        } else {
          this.titlechoose = 'Chọn ngân hàng';
          this.showTypeSelect = false;
          this.code = null;
          this.serial = null;
        }
        if (this.havebankid === false) {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(this.banksoption), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var bankshow = _step6.value;

              if (typeid === bankshow.type_id) {
                this.banksfilter = this.banksfilter.concat(bankshow);
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }

          this.bank_key = this.banksfilter[0]['key'];
          this.listbankchannel(this.bank_key);
        } else {
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = get_iterator_default()(this.banksoption), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _bankshow = _step7.value;

              if (typeid === _bankshow.type_id && this.bank_key === _bankshow.key) {
                this.banksfilter = this.banksfilter.concat(_bankshow);
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
        this.showBank = true;
        this.showChannel = true;
      }
    },
    listbankchannel: function listbankchannel(bankkey) {
      this.showChannel = false;
      this.channel_key = null;
      this.channelsfilter = [];
      this.channelmin = null;
      this.channelmax = null;
      this.needBank = null;
      this.need_scratchcard = null;
      this.success_rate = null;
      this.need_name = false;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(this.channels), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var bankchannelshow = _step8.value;

          if (bankchannelshow.type_id === this.typeid && bankchannelshow.related_bankid === bankkey) {
            this.channelsfilter = this.channelsfilter.concat(bankchannelshow);
            if (bankchannelshow.default_show) {
              this.channel_key = bankchannelshow.key;
              this.channelmin = bankchannelshow.min_load;
              this.channelmax = bankchannelshow.max_load;
              this.needBank = bankchannelshow.need_bank;
              this.channeldesc = bankchannelshow.description;
              this.need_scratchcard = bankchannelshow.need_scratchcard;
              this.success_rate = bankchannelshow.success_rate;
              this.need_name = bankchannelshow.need_name;
            } else {
              this.channel_key = this.channelsfilter[0]['key'];
              this.channelmin = this.channelsfilter[0]['min_load'];
              this.channelmax = this.channelsfilter[0]['max_load'];
              this.needBank = this.channelsfilter[0]['need_bank'];
              this.channeldesc = this.channelsfilter[0]['description'];
              this.need_scratchcard = this.channelsfilter[0]['need_scratchcard'];
              this.success_rate = this.channelsfilter[0]['success_rate'];
              this.need_name = this.channelsfilter[0]['need_name'];
            }
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      if (bankkey !== null) {
        this.showChannel = true;
      }
    },
    channelselect: function channelselect(channelkey) {
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = get_iterator_default()(this.channels), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var selectchannel = _step9.value;

          if (this.bank_key === null) {
            if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key) {
              this.channelmin = selectchannel.min_load;
              this.channelmax = selectchannel.max_load;
              this.needBank = selectchannel.need_bank;
              this.channeldesc = selectchannel.description;
              this.need_scratchcard = selectchannel.need_scratchcard;
              this.success_rate = selectchannel.success_rate;
              this.need_name = selectchannel.need_name;
            }
          } else {
            if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key && this.bank_key === selectchannel.related_bankid) {
              this.channelmin = selectchannel.min_load;
              this.channelmax = selectchannel.max_load;
              this.needBank = selectchannel.need_bank;
              this.channeldesc = selectchannel.description;
              this.need_scratchcard = selectchannel.need_scratchcard;
              this.success_rate = selectchannel.success_rate;
              this.need_name = selectchannel.need_name;
              this.handleLoadCardTypeSelect();
            }
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    },
    check: function check() {
      this.$vux.loading.show({
        text: 'Loading'
      });
      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.channelmin;
      var maxLoad = this.channelmax;
      if (this.bank_key === null && (this.typeid === 12 || this.typeid === 13)) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng chọn ngân hàng！',
          'type': 'warn'
        });
        return;
      }

      if (this.bank_key === null && this.typeid === 14) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng chọn loại thẻ！',
          'type': 'warn'
        });
        return;
      }
      if (this.showTypeSelect === true && (this.code === null || this.code.trim() === '' || this.serial === null || this.serial.trim() === '')) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng nhập Mã thẻ và số seri！',
          'type': 'warn'
        });
        return;
      }

      if (this.need_name && this.name === '') {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng nhập tên thật！',
          'type': 'warn'
        });
        return;
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        this.submit(submitAmout);
      } else {
        this.$vux.loading.hide();
        this.$vux.alert.show({
          content: 'Hỗ trợ nạp tiền ' + minLoad + 'VND ~ ' + maxLoad + ' VND '
        });
      }
    },
    generalDepositCreateParams: function generalDepositCreateParams(amount) {
      var self = this;
      return {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.channel_key,
        bank_id: self.bank_key,
        name: self.name,
        amount: amount,
        bank_card_no: self.bank_card_no
      };
    },
    vinaPhoneCardDepositCreateParams: function vinaPhoneCardDepositCreateParams(amount) {
      var self = this;
      return {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.channel_key,
        bank_id: self.bank_key,
        name: self.name,
        amount: amount,
        serial: self.serial,
        code: self.code,
        type: self.bank_key
      };
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;
      var params = this.need_scratchcard ? this.vinaPhoneCardDepositCreateParams(submitAmout) : this.generalDepositCreateParams(submitAmout);

      self.$models.Deposit.create(params).then(function (response) {
        self.pay_click = false;
        if (!response.data.success) {
          self.$vux.loading.hide();
          self.$router.replace({
            path: '/error',
            query: {
              title: response.data.message,
              description1: 'Đặt hàng：' + self.app_order_no,
              description2: 'Kênh số：#' + self.channel_key,
              description3: ''
            }
          });
          return;
        }
        cookie["a" /* default */].remove('historys');
        self.load_url = response.data.data.load_url;
        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          return;
        } else if (response.data.data.load_straight === 2) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url,
              deposit_type: response.data.data.deposit_type,
              platform_id: self.channel_key,
              from_url: self.$route.path
            }
          });
          return;
        }
        if (self.need_scratchcard && self.typeid === 14) {
          self.$router.replace({ path: '/finished' });
          return;
        }

        self.showPayPage = true;
        setTimeout(function () {
          self.$vux.loading.hide();
        }, 2000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: 'Vui lòng hoàn tất thanh toán trong cửa sổ mở mới<br />Nếu đã hoàn tất, hãy nhấp vào "hoàn tất thanh toán"',
        confirmText: 'Hoàn tất thanh toán',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: 'Đơn đặt hàng được bắt đầu quá thường xuyên',
              description1: 'Xin lỗi vì bạn thường xuyên đặt hàng nhưng không gửi thanh toán',
              description2: 'Xin vui lòng mất năm phút nghỉ để thử lại, cảm ơn bạn đã hợp tác của bạn'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
        console.log(historys);
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },

    numberWithCommas: numberWithCommas,
    handleLoadCardTypeSelect: function handleLoadCardTypeSelect() {
      this.code = null;
      this.serial = null;
      this.showTypeSelect = this.typeid === 14 && this.need_scratchcard === 1;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit2.vue




















/* harmony default export */ var components_Deposit2 = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Loading: loading["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    document.body.className = 'charge deposit2';
  },
  data: function data() {
    return {
      typeoption: [],
      typeid: null,
      channels: [],
      channelsfilter: [],
      channel_key: null,
      showChannel: false,
      banksoption: [],
      banksfilter: [],
      bank_key: null,
      needBank: null,
      showBank: false,
      havebankid: false,
      titlechoose: 'Chọn ngân hàng',
      channeldesc: '',
      channelmin: null,
      success_rate: null,
      channelmax: null,
      orientpos: false,
      rotate: false,
      query: '',
      title: '充值',
      platform_show: {
        desc: ''
      },
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showTypeSelect: false,
      code: null,
      serial: null,
      need_bank: null,
      need_scratchcard: 0,
      bank_id: null,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      videoon: false,
      videooff: true,
      popvid: false,
      need_name: false
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    this.handleOrientationChange();
    window.addEventListener('orientationchange', this.handleOrientationChange);
    this.checkOrderCounts();
    var self = this;
    self.channel_key = typeof self.$route.query.platform_id === 'undefined' ? 1 : JSON.parse(self.$route.query.platform_id);

    self.$models.Deposit.info({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (typePlatforms) {
      self.checkDepositExists(typePlatforms.data.data);
      self.rotate = typePlatforms.data.data.rotate_prompt;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(typePlatforms.data.data.types), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var typePlatform = _step.value;

          var typelist = {
            key: typePlatform.type_id,
            value: typePlatform.display_name,
            icon: 'static/images/logo/' + typePlatform.icon + '.png',
            isfeatured: typePlatform.is_featured
          };
          var channellist = {};
          if (!isNeedBank(typePlatform.type_id)) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(typePlatform.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var typemobileshow = _step2.value;

                var showmobile, defaultmobile;
                showmobile = typemobileshow.mobile_show;
                defaultmobile = typemobileshow.mobile_default;
                channellist = {
                  show_view: Boolean(showmobile),
                  default_show: Boolean(defaultmobile),
                  key: typemobileshow.id,
                  value: typemobileshow.name,
                  bank_id: typemobileshow.bank_id,
                  banks: typemobileshow.banks,
                  amount_list: typemobileshow.custom_amounts,
                  description: typemobileshow.description,
                  icon: 'static/images/logo/' + typemobileshow.icon + '.png',
                  max_load: typemobileshow.max_load,
                  min_load: typemobileshow.min_load,
                  need_bank: typemobileshow.need_bank,
                  static_amount: typemobileshow.static_amount,
                  type_id: typemobileshow.type_id,
                  need_scratchcard: typemobileshow.need_scratchcard,
                  success_rate: typemobileshow.success_rate,
                  need_name: typemobileshow.need_name
                };
                self.channels = self.channels.concat(channellist);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            self.typeoption = self.typeoption.concat(typelist);
          } else {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = get_iterator_default()(typePlatform.data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _typemobileshow = _step3.value;

                var bankshortname = BANKS[_typemobileshow.icon];
                if (bankshortname === '' || bankshortname === undefined) {
                  bankshortname = _typemobileshow.name;
                }
                var banklist = {
                  key: _typemobileshow.icon,
                  value: bankshortname,
                  icon: 'static/images/vnbanks/icons/' + _typemobileshow.icon + '.png',
                  children: _typemobileshow.children,
                  type_id: typePlatform.type_id
                };
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                  for (var _iterator4 = get_iterator_default()(_typemobileshow.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var typemobileshow2 = _step4.value;

                    showmobile = typemobileshow2.mobile_show;
                    defaultmobile = typemobileshow2.mobile_default;
                    channellist = {
                      show_view: Boolean(showmobile),
                      default_show: Boolean(defaultmobile),
                      key: typemobileshow2.id,
                      value: typemobileshow2.name,
                      bank_id: typemobileshow2.bank_id,
                      banks: typemobileshow2.banks,
                      amount_list: typemobileshow2.custom_amounts,
                      description: typemobileshow2.description,
                      icon: 'static/images/logo/' + typemobileshow2.icon + '.png',
                      max_load: typemobileshow2.max_load,
                      min_load: typemobileshow2.min_load,
                      need_bank: typemobileshow2.need_bank,
                      static_amount: typemobileshow2.static_amount,
                      type_id: typemobileshow2.type_id,
                      related_bankid: _typemobileshow.icon,
                      related_bankname: _typemobileshow.name,
                      need_scratchcard: typemobileshow2.need_scratchcard,
                      success_rate: typemobileshow2.success_rate,
                      need_name: typemobileshow2.need_name
                    };
                    self.channels = self.channels.concat(channellist);
                  }
                } catch (err) {
                  _didIteratorError4 = true;
                  _iteratorError4 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                      _iterator4.return();
                    }
                  } finally {
                    if (_didIteratorError4) {
                      throw _iteratorError4;
                    }
                  }
                }

                self.banksoption = self.banksoption.concat(banklist);
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            self.typeoption = self.typeoption.concat(typelist);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (['', null, '0.00'].includes(typePlatforms.data.data.amount)) {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = typePlatforms.data.data.amount;
      }
      self.app_order_no = typePlatforms.data.data.app_order_no;
      if (self.typeoption.length === 0) {
        self.$router.replace({
          path: '/error',
          query: {
            title: 'Ngân hàng này đang bảo trì.<br />Vui lòng quay lại sau.',
            description1: '\u0110\u1EB7t h\xE0ng\uFF1A' + typePlatforms.data.data.app_order_no,
            description2: 'C\xE1c lo\u1EA1i thanh to\xE1n\uFF1A ' + (typePlatforms.data.data.type === null ? 'Không có kênh nào tại thời gian này' : typePlatforms.data.data.type)
          }
        });
      } else if (self.typeoption.length === 1) {
        self.typeid = self.typeoption[0]['key'];
        if (typePlatforms.data.data.bank_id === null) {
          self.havebankid = false;
          self.listChannel(self.typeid);
          if (!(self.showAmountInput === true || isNeedBank(self.typeid) && self.banksfilter.length > 1 || self.channelsfilter.length > 1)) {
            self.check();
          }
        } else {
          self.havebankid = true;
          self.bank_key = typePlatforms.data.data.bank_id;
          self.listChannel(self.typeid);
          self.listbankchannel(typePlatforms.data.data.bank_id);
          if (!(self.showAmountInput === true || self.channelsfilter.length > 1)) {
            self.check();
          }
        }
      } else if (self.typeoption.length > 1) {
        self.typeid = self.typeoption[0]['key'];
        self.listChannel(self.typeid);
        if (isNeedBank(self.typeid)) {
          self.listbankchannel(self.banksfilter[0]['key']);
          self.bank_key = self.banksfilter[0]['key'];
        }
      }
    });

    sessionStorage.setItem('prev', this.$route.fullPath);
  },

  methods: {
    checkDepositExists: function checkDepositExists(orderInfo) {

      if (orderInfo === undefined || orderInfo === '') {
        this.$router.replace({
          path: '/error',
          query: {
            title: 'Đơn hàng không tồn tại',
            description1: 'Lỗi'
          }
        });
      }

      var hasDeposit = orderInfo.has_deposit,
          appOrderNumber = orderInfo.app_order_no;

      if (hasDeposit) {
        this.$router.replace({
          path: '/error',
          query: {
            title: 'Đơn hàng đã tồn tại',
            description1: '\u0110\u1EB7t h\xE0ng\uFF1A' + appOrderNumber
          }
        });
      }
    },
    handleOrientationChange: function handleOrientationChange() {
      var isRotate = window.screen.orientation && window.screen.orientation.angle > 0 || !window.matchMedia('(orientation: portrait)').matches;

      this.orientpos = /Android|iPhone|iPad|iPod|iOS|BlackBerry|IEMobile/i.test(navigator.userAgent) ? isRotate : false;
    },
    closeIt: function closeIt() {
      this.orientpos = false;
    },
    helpcenter: function helpcenter() {
      this.videoon = true;
      this.videooff = false;
    },
    backtomain: function backtomain() {
      this.videoon = false;
      this.videooff = true;
    },
    closevid: function closevid() {
      var video = document.getElementById('videoinfo');
      video.removeAttribute('src');
      this.popvid = false;
    },
    viewvideo: function viewvideo(videoname) {
      this.popvid = true;
      setTimeout(function () {
        var video = document.getElementById('videoinfo');
        video.setAttribute('type', 'video/mp4');
        video.setAttribute('src', 'static/images/helpcenter/' + videoname + '.mp4');
        video.load();
        video.play();
      }, 500);
    },
    listChannel: function listChannel(typeid) {
      this.typeid = typeid;
      if (!isNeedBank(typeid)) {
        this.showChannel = true;
        this.channel_key = null;
        this.bank_key = null;
        this.channelsfilter = [];
        this.showBank = false;
        this.banksfilter = [];
        this.channelmin = null;
        this.channelmax = null;
        this.success_rate = null;
        this.showTypeSelect = false;
        this.need_scratchcard = null;
        this.need_name = false;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = get_iterator_default()(this.channels), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var channelshow = _step5.value;

            if (typeid === channelshow.type_id) {
              this.channelsfilter = this.channelsfilter.concat(channelshow);
              if (channelshow.default_show) {
                this.channel_key = channelshow.key;
                this.channelmin = channelshow.min_load;
                this.channelmax = channelshow.max_load;
                this.needBank = channelshow.need_bank;
                this.channeldesc = channelshow.description;
                this.need_scratchcard = channelshow.need_scratchcard;
                this.success_rate = channelshow.success_rate;
                this.need_name = channelshow.need_name;
              } else {
                this.channel_key = this.channelsfilter[0]['key'];
                this.channelmin = this.channelsfilter[0]['min_load'];
                this.channelmax = this.channelsfilter[0]['max_load'];
                this.needBank = this.channelsfilter[0]['need_bank'];
                this.channeldesc = this.channelsfilter[0]['description'];
                this.need_scratchcard = this.channelsfilter[0]['need_scratchcard'];
                this.success_rate = this.channelsfilter[0]['success_rate'];
                this.need_name = this.channelsfilter[0]['need_name'];
              }
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      } else {
        this.showBank = false;
        this.banksfilter = [];
        if (typeid === 14) {
          this.titlechoose = 'Chọn loại thẻ';
          this.handleLoadCardTypeSelect();
        } else {
          this.titlechoose = 'Chọn ngân hàng';
          this.showTypeSelect = false;
          this.code = null;
          this.serial = null;
        }
        if (this.havebankid === false) {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(this.banksoption), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var bankshow = _step6.value;

              if (typeid === bankshow.type_id) {
                this.banksfilter = this.banksfilter.concat(bankshow);
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }

          this.bank_key = this.banksfilter[0]['key'];
          this.listbankchannel(this.bank_key);
        } else {
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = get_iterator_default()(this.banksoption), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _bankshow = _step7.value;

              if (typeid === _bankshow.type_id && this.bank_key === _bankshow.key) {
                this.banksfilter = this.banksfilter.concat(_bankshow);
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
        this.showBank = true;
        this.showChannel = true;
      }
    },
    listbankchannel: function listbankchannel(bankkey) {
      this.showChannel = false;
      this.channel_key = null;
      this.channelsfilter = [];
      this.channelmin = null;
      this.channelmax = null;
      this.needBank = null;
      this.need_scratchcard = null;
      this.success_rate = null;
      this.need_name = false;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(this.channels), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var bankchannelshow = _step8.value;

          if (bankchannelshow.type_id === this.typeid && bankchannelshow.related_bankid === bankkey) {
            this.channelsfilter = this.channelsfilter.concat(bankchannelshow);
            if (bankchannelshow.default_show) {
              this.channel_key = bankchannelshow.key;
              this.channelmin = bankchannelshow.min_load;
              this.channelmax = bankchannelshow.max_load;
              this.needBank = bankchannelshow.need_bank;
              this.channeldesc = bankchannelshow.description;
              this.need_scratchcard = bankchannelshow.need_scratchcard;
              this.success_rate = bankchannelshow.success_rate;
              this.need_name = bankchannelshow.need_name;
            } else {
              this.channel_key = this.channelsfilter[0]['key'];
              this.channelmin = this.channelsfilter[0]['min_load'];
              this.channelmax = this.channelsfilter[0]['max_load'];
              this.needBank = this.channelsfilter[0]['need_bank'];
              this.channeldesc = this.channelsfilter[0]['description'];
              this.need_scratchcard = this.channelsfilter[0]['need_scratchcard'];
              this.success_rate = this.channelsfilter[0]['success_rate'];
              this.need_name = this.channelsfilter[0]['need_name'];
            }
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      if (bankkey !== null) {
        this.showChannel = true;
      }
    },
    channelselect: function channelselect(channelkey) {
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = get_iterator_default()(this.channels), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var selectchannel = _step9.value;

          if (this.bank_key === null) {
            if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key) {
              this.channelmin = selectchannel.min_load;
              this.channelmax = selectchannel.max_load;
              this.needBank = selectchannel.need_bank;
              this.channeldesc = selectchannel.description;
              this.need_scratchcard = selectchannel.need_scratchcard;
              this.success_rate = selectchannel.success_rate;
              this.need_name = selectchannel.need_name;
            }
          } else {
            if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key && this.bank_key === selectchannel.related_bankid) {
              this.channelmin = selectchannel.min_load;
              this.channelmax = selectchannel.max_load;
              this.needBank = selectchannel.need_bank;
              this.channeldesc = selectchannel.description;
              this.need_scratchcard = selectchannel.need_scratchcard;
              this.success_rate = selectchannel.success_rate;
              this.need_name = selectchannel.need_name;
              this.handleLoadCardTypeSelect();
            }
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    },
    check: function check() {
      this.$vux.loading.show({
        text: 'Loading'
      });
      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.channelmin;
      var maxLoad = this.channelmax;
      if (this.bank_key === null && (this.typeid === 12 || this.typeid === 13)) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng chọn ngân hàng！',
          'type': 'warn'
        });
        return;
      }

      if (this.bank_key === null && this.typeid === 14) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng chọn loại thẻ！',
          'type': 'warn'
        });
        return;
      }
      if (this.showTypeSelect === true && (this.code === null || this.code.trim() === '' || this.serial === null || this.serial.trim() === '')) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng nhập Mã thẻ và số seri！',
          'type': 'warn'
        });
        return;
      }

      if (this.need_name && this.name === '') {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng nhập tên thật！',
          'type': 'warn'
        });
        return;
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        this.submit(submitAmout);
      } else {
        this.$vux.loading.hide();
        this.$vux.alert.show({
          content: 'Hỗ trợ nạp tiền ' + minLoad + 'VND ~ ' + maxLoad + ' VND '
        });
      }
    },
    generalDepositCreateParams: function generalDepositCreateParams(amount) {
      var self = this;
      return {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.channel_key,
        bank_id: self.bank_key,
        name: self.name,
        amount: amount,
        bank_card_no: self.bank_card_no
      };
    },
    vinaPhoneCardDepositCreateParams: function vinaPhoneCardDepositCreateParams(amount) {
      var self = this;
      return {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.channel_key,
        bank_id: self.bank_key,
        name: self.name,
        amount: amount,
        serial: self.serial,
        code: self.code,
        type: self.bank_key
      };
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;
      var params = this.need_scratchcard ? this.vinaPhoneCardDepositCreateParams(submitAmout) : this.generalDepositCreateParams(submitAmout);

      self.$models.Deposit.create(params).then(function (response) {
        self.pay_click = false;
        if (!response.data.success) {
          self.$vux.loading.hide();
          self.$router.replace({
            path: '/error',
            query: {
              title: response.data.message,
              description1: 'Đặt hàng：' + self.app_order_no,
              description2: 'Kênh số：#' + self.channel_key,
              description3: ''
            }
          });
          return;
        }
        cookie["a" /* default */].remove('historys');
        self.load_url = response.data.data.load_url;
        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          return;
        } else if (response.data.data.load_straight === 2) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url,
              deposit_type: response.data.data.deposit_type,
              platform_id: self.channel_key,
              from_url: self.$route.path
            }
          });
          return;
        }
        if (self.need_scratchcard && self.typeid === 14) {
          self.$router.replace({ path: '/finished' });
          return;
        }

        self.showPayPage = true;
        setTimeout(function () {
          self.$vux.loading.hide();
        }, 2000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: 'Vui lòng hoàn tất thanh toán trong cửa sổ mở mới<br />Nếu đã hoàn tất, hãy nhấp vào "hoàn tất thanh toán"',
        confirmText: 'Hoàn tất thanh toán',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: 'Đơn đặt hàng được bắt đầu quá thường xuyên',
              description1: 'Xin lỗi vì bạn thường xuyên đặt hàng nhưng không gửi thanh toán',
              description2: 'Xin vui lòng mất năm phút nghỉ để thử lại, cảm ơn bạn đã hợp tác của bạn'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
        console.log(historys);
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },

    numberWithCommas: numberWithCommas,
    handleLoadCardTypeSelect: function handleLoadCardTypeSelect() {
      this.code = null;
      this.serial = null;
      this.showTypeSelect = this.typeid === 14 && this.need_scratchcard === 1;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4efb60cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Deposit2.vue
var Deposit2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-add cssoverwrite",staticStyle:{"height":"100%"}},[_vm._m(0),_vm._v(" "),(_vm.videooff)?_c('div',[_c('view-box',{attrs:{"body-padding-top":"0px","body-padding-bottom":"0px"}},[_c('template',{slot:"default"},[_c('div',{staticClass:"left-con",class:{'oneonly':_vm.typeoption.length == 1}},[_c('div',{staticClass:"typecon"},[_c('radio',{attrs:{"options":_vm.typeoption},on:{"on-change":_vm.listChannel},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('div',{staticClass:"type-icon"},[_c('img',{attrs:{"width":"38","src":props.icon}})]),_vm._v(" "),_c('div',{staticClass:"type-label"},[_vm._v(_vm._s(props.label))]),_vm._v(" "),( _vm.typeoption[props.index].isfeatured)?_c('div',{staticClass:"featuredtype"},[_c('img',{attrs:{"src":"static/images/ui/deposit/reco-mobile.png","alt":""}})]):_vm._e()]}}],null,false,2571710570),model:{value:(_vm.typeid),callback:function ($$v) {_vm.typeid=$$v},expression:"typeid"}})],1)]),_vm._v(" "),_c('div',{staticClass:"right-con",class:{'oneonly':_vm.typeoption.length == 1}},[(_vm.showAmountInput == false)?_c('div',{staticClass:"amount-con"},[_c('x-input',{attrs:{"title":"Số tiền ","disabled":true,"value":'đ '+ _vm.numberWithCommas(_vm.show_amount)}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"orderno-con landscapecon",class:{'fullwidth': _vm.showAmountInput == true}},[_c('x-input',{attrs:{"disabled":true,"value":'Mã giao dịch    '+_vm.app_order_no,"text-align":"right"}})],1),_vm._v(" "),_c('div',{staticClass:"orderno-con portraitcon",class:{'fullwidth': _vm.showAmountInput == true}},[_c('x-input',{attrs:{"disabled":true,"title":"Mã giao dịch","value":_vm.app_order_no,"text-align":"right"}})],1),_vm._v(" "),_c('group',{staticClass:"linecon",attrs:{"gutter":"10px"}},[(_vm.showBank)?_c('group',{staticClass:"bankdisplay",attrs:{"gutter":"0px"}},[_c('div',{staticClass:"banktitle"},[_vm._v(_vm._s(_vm.titlechoose))]),_vm._v(" "),_c('radio',{attrs:{"options":_vm.banksfilter},on:{"on-change":_vm.listbankchannel},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"line-height":"40px","display":"table"}},[_c('span',{staticStyle:{"display":"table-cell","vertical-align":"middle"}},[_c('img',{staticClass:"rmargin-20px",staticStyle:{"margin-right":"10px","vertical-align":"middle"},attrs:{"width":"40","src":props.icon}})]),_vm._v(" "),_c('span',{class:{'lineheightadjust':props.label == 'Vietnam Mobile'},staticStyle:{"display":"table-cell","line-height":"18px","vertical-align":"middle","font-size":"15px"}},[_vm._v(_vm._s(props.label))])])]}}],null,false,3537741527),model:{value:(_vm.bank_key),callback:function ($$v) {_vm.bank_key=$$v},expression:"bank_key"}})],1):_vm._e(),_vm._v(" "),(_vm.showChannel)?_c('group',{attrs:{"gutter":"0px"}},[_c('div',{staticClass:"channeltitle"},[_vm._v("Chọn kênh")]),_vm._v(" "),_c('div',{staticClass:"channeldropdown"},[_c('popup-radio',{class:{'onechan':_vm.channelsfilter.length == 1},attrs:{"options":_vm.channelsfilter,"id":_vm.channelsfilter[0].icon.substring(19,_vm.channelsfilter[0].icon.length-4),"readonly":_vm.channelsfilter.length == 1},on:{"on-change":_vm.channelselect},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('div',{staticClass:"channelpop"},[_c('div',{staticClass:"channel-icon"},[_c('img',{attrs:{"width":"40","src":props.icon}})]),_vm._v(" "),_c('div',{staticClass:"channel-label"},[_c('div',{staticClass:"labelchannel"},[_vm._v(_vm._s(props.label))]),_vm._v(" "),_c('div',{staticClass:"channelrange"},[_vm._v(_vm._s(_vm.numberWithCommas(_vm.channelsfilter[props.index].min_load))+"-"+_vm._s(_vm.numberWithCommas(_vm.channelsfilter[props.index].max_load))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"succrate"},[_c('div',{staticClass:"c100 green",class:_vm.channelsfilter[props.index].success_rate > 60 ? 'green p'+ parseInt(_vm.channelsfilter[props.index].success_rate): 'yellow p' + parseInt(_vm.channelsfilter[props.index].success_rate)},[_c('span',[_vm._v(_vm._s(_vm.channelsfilter[props.index].success_rate + '%'))]),_vm._v(" "),_c('div',{staticClass:"slice"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_c('div',{staticClass:"fill"})])])])])]}}],null,false,2633822423),model:{value:(_vm.channel_key),callback:function ($$v) {_vm.channel_key=$$v},expression:"channel_key"}})],1)]):_vm._e(),_vm._v(" "),(_vm.showTypeSelect)?_c('div',{staticClass:"vinaphonecon"},[_c('group',{attrs:{"gutter":"0"}},[_c('x-input',{staticClass:"x-input-default",attrs:{"type":"text","placeholder":"Mã thẻ","text-align":"left"},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}),_vm._v(" "),_c('x-input',{staticClass:"x-input-default",attrs:{"type":"text","placeholder":"Số seri","text-align":"left"},model:{value:(_vm.serial),callback:function ($$v) {_vm.serial=$$v},expression:"serial"}})],1)],1):_vm._e(),_vm._v(" "),_c('group',{attrs:{"gutter":"0"}},[(_vm.need_name)?_c('x-input',{staticClass:"x-input-default",attrs:{"type":"text","placeholder":"tên người trả tiền","text-align":"left"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}):_vm._e()],1),_vm._v(" "),(_vm.showAmountInput)?_c('div',{staticClass:"showamountcon"},[_c('group',{attrs:{"gutter":"0","title":'Tối thiểu ' + _vm.channelmin + ' VND Cao nhất ' + _vm.channelmax + ' VND'}},[(_vm.show_amount_input)?_c('x-input',{attrs:{"title":_vm.input_amount * 1 + ' Tách rời',"type":"tel","placeholder":"Nhập một khoản tiền tùy chỉnh","text-align":"right","max":9},model:{value:(_vm.input_amount),callback:function ($$v) {_vm.input_amount=$$v},expression:"input_amount"}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('box',{attrs:{"gap":"15px 15px 15px 15px"}},[_c('x-button',{attrs:{"type":"primary","disabled":_vm.pay_click},nativeOn:{"click":function($event){return _vm.check.apply(null, arguments)}}},[_vm._v("Thanh toán ngay")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"font-size":"0.8em","padding":"10px 0px","text-align":"left"}},[_c('p',[_vm._v(_vm._s(_vm.channeldesc))])])],1),_vm._v(" "),_c('popup',{attrs:{"height":"100%"},on:{"on-hide":_vm.showAsk},model:{value:(_vm.showPayPage),callback:function ($$v) {_vm.showPayPage=$$v},expression:"showPayPage"}},[_c('view-box',{staticStyle:{"height":"100%"},attrs:{"slot":"default","body-padding-top":"50px","body-padding-bottom":"0"},slot:"default"},[_c('x-button',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100","border-radius":"0","height":"58px"},attrs:{"slot":"header","text":"完成","type":"primary"},nativeOn:{"click":function($event){_vm.showPayPage = false}},slot:"header"}),_vm._v(" "),(_vm.showPayPage)?_c('iframe',{staticStyle:{"position":"absolute","border":"none","top":"50px"},attrs:{"src":_vm.load_url,"width":"100%","height":"100%"}}):_vm._e()],1)],1)],1)],2)],1):_vm._e(),_vm._v(" "),(_vm.videoon)?_c('div',{staticClass:"videoPage"},[_c('div',{staticClass:"backicon",on:{"click":_vm.backtomain}},[_c('img',{attrs:{"src":"static/images/helpcenter/back-icon.png"}})]),_vm._v(" "),_c('div',{staticClass:"videoheader"},[_vm._v("TRUNG TÂM TRỢ GIÚP")]),_vm._v(" "),_c('div',{staticClass:"videocon"},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.viewvideo('banktransfer')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-bank.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('onlinebank')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-onlinebank.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('momo')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-momo.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('viettel')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-viettel.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('zalo')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-zalo.jpg"}})])])]),_vm._v(" "),(_vm.popvid)?_c('div',{staticClass:"videobg"},[_c('div',{staticClass:"videoplayercon"},[_c('video',{attrs:{"src":"","id":"videoinfo","controls":""}}),_vm._v(" "),_c('div',{staticClass:"closebtn",on:{"click":_vm.closevid}},[_c('img',{attrs:{"src":"static/images/helpcenter/closebtn.png"}})])])]):_vm._e()]):_vm._e()])}
var Deposit2_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"helpicon"},[_c('a',{attrs:{"href":"https://www.1bestpay.com/helpcenter","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{attrs:{"src":"static/images/helpcenter/help-center-icon-green.png"}})])])}]
var Deposit2_esExports = { render: Deposit2_render, staticRenderFns: Deposit2_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Deposit2 = (Deposit2_esExports);
// CONCATENATED MODULE: ./src/components/Deposit2.vue
var Deposit2_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Deposit2___vue_template_functional__ = false
/* styles */
var Deposit2___vue_styles__ = null
/* scopeId */
var Deposit2___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Deposit2___vue_module_identifier__ = null
var Deposit2_Component = Deposit2_normalizeComponent(
  components_Deposit2,
  selectortype_template_index_0_src_components_Deposit2,
  Deposit2___vue_template_functional__,
  Deposit2___vue_styles__,
  Deposit2___vue_scopeId__,
  Deposit2___vue_module_identifier__
)

/* harmony default export */ var src_components_Deposit2 = (Deposit2_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit2Dark.vue




















/* harmony default export */ var Deposit2Dark = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Loading: loading["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    document.body.className = 'charge deposit2 dark';
  },
  data: function data() {
    return {
      typeoption: [],
      typeid: null,
      channels: [],
      channelsfilter: [],
      channel_key: null,
      showChannel: false,
      banksoption: [],
      banksfilter: [],
      bank_key: null,
      needBank: null,
      showBank: false,
      havebankid: false,
      titlechoose: 'Chọn ngân hàng',
      channeldesc: '',
      channelmin: null,
      success_rate: null,
      channelmax: null,
      orientpos: false,
      rotate: false,
      query: '',
      title: '充值',
      platform_show: {
        desc: ''
      },
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showTypeSelect: false,
      code: null,
      serial: null,
      need_bank: null,
      need_scratchcard: 0,
      bank_id: null,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      videoon: false,
      videooff: true,
      popvid: false,
      need_name: false
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    this.handleOrientationChange();
    window.addEventListener('orientationchange', this.handleOrientationChange);
    this.checkOrderCounts();
    var self = this;
    self.channel_key = typeof self.$route.query.platform_id === 'undefined' ? 1 : JSON.parse(self.$route.query.platform_id);

    self.$models.Deposit.info({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (typePlatforms) {
      self.checkDepositExists(typePlatforms.data.data);
      self.rotate = typePlatforms.data.data.rotate_prompt;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(typePlatforms.data.data.types), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var typePlatform = _step.value;

          var typelist = {
            key: typePlatform.type_id,
            value: typePlatform.display_name,
            icon: 'static/images/logo/' + typePlatform.icon + '.png',
            isfeatured: typePlatform.is_featured
          };
          var channellist;
          if (!isNeedBank(typePlatform.type_id)) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(typePlatform.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var typemobileshow = _step2.value;

                var showmobile, defaultmobile;
                showmobile = typemobileshow.mobile_show;
                defaultmobile = typemobileshow.mobile_default;
                channellist = {
                  show_view: Boolean(showmobile),
                  default_show: Boolean(defaultmobile),
                  key: typemobileshow.id,
                  value: typemobileshow.name,
                  bank_id: typemobileshow.bank_id,
                  banks: typemobileshow.banks,
                  amount_list: typemobileshow.custom_amounts,
                  description: typemobileshow.description,
                  icon: 'static/images/logo/' + typemobileshow.icon + '.png',
                  max_load: typemobileshow.max_load,
                  min_load: typemobileshow.min_load,
                  need_bank: typemobileshow.need_bank,
                  static_amount: typemobileshow.static_amount,
                  type_id: typemobileshow.type_id,
                  need_scratchcard: typemobileshow.need_scratchcard,
                  success_rate: typemobileshow.success_rate,
                  need_name: typemobileshow.need_name
                };
                self.channels = self.channels.concat(channellist);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            self.typeoption = self.typeoption.concat(typelist);
          } else {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = get_iterator_default()(typePlatform.data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _typemobileshow = _step3.value;

                var bankshortname = BANKS[_typemobileshow.icon];
                if (bankshortname === '' || bankshortname === undefined) {
                  bankshortname = _typemobileshow.name;
                }
                var banklist = {
                  key: _typemobileshow.icon,
                  value: bankshortname,
                  icon: 'static/images/vnbanks/icons/' + _typemobileshow.icon + '.png',
                  children: _typemobileshow.children,
                  type_id: typePlatform.type_id
                };
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                  for (var _iterator4 = get_iterator_default()(_typemobileshow.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var typemobileshow2 = _step4.value;

                    showmobile = typemobileshow2.mobile_show;
                    defaultmobile = typemobileshow2.mobile_default;
                    channellist = {
                      show_view: Boolean(showmobile),
                      default_show: Boolean(defaultmobile),
                      key: typemobileshow2.id,
                      value: typemobileshow2.name,
                      bank_id: typemobileshow2.bank_id,
                      banks: typemobileshow2.banks,
                      amount_list: typemobileshow2.custom_amounts,
                      description: typemobileshow2.description,
                      icon: 'static/images/logo/' + typemobileshow2.icon + '.png',
                      max_load: typemobileshow2.max_load,
                      min_load: typemobileshow2.min_load,
                      need_bank: typemobileshow2.need_bank,
                      static_amount: typemobileshow2.static_amount,
                      type_id: typemobileshow2.type_id,
                      related_bankid: _typemobileshow.icon,
                      related_bankname: _typemobileshow.name,
                      need_scratchcard: typemobileshow2.need_scratchcard,
                      success_rate: typemobileshow2.success_rate,
                      need_name: typemobileshow2.need_name
                    };
                    self.channels = self.channels.concat(channellist);
                  }
                } catch (err) {
                  _didIteratorError4 = true;
                  _iteratorError4 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                      _iterator4.return();
                    }
                  } finally {
                    if (_didIteratorError4) {
                      throw _iteratorError4;
                    }
                  }
                }

                self.banksoption = self.banksoption.concat(banklist);
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            self.typeoption = self.typeoption.concat(typelist);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (['', null, '0.00'].includes(typePlatforms.data.data.amount)) {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = typePlatforms.data.data.amount;
      }
      self.app_order_no = typePlatforms.data.data.app_order_no;
      if (self.typeoption.length === 0) {
        self.$router.replace({
          path: '/error',
          query: {
            title: 'Ngân hàng này đang bảo trì.<br />Vui lòng quay lại sau.',
            description1: '\u0110\u1EB7t h\xE0ng\uFF1A' + typePlatforms.data.data.app_order_no,
            description2: 'C\xE1c lo\u1EA1i thanh to\xE1n\uFF1A ' + (typePlatforms.data.data.type === null ? 'Không có kênh nào tại thời gian này' : typePlatforms.data.data.type)
          }
        });
      } else if (self.typeoption.length === 1) {
        self.typeid = self.typeoption[0]['key'];
        if (typePlatforms.data.data.bank_id === null) {
          self.havebankid = false;
          self.listChannel(self.typeid);
          if (!(self.showAmountInput === true || isNeedBank(self.typeid) && self.banksfilter.length > 1 || self.channelsfilter.length > 1)) {
            self.check();
          }
        } else {
          self.havebankid = true;
          self.bank_key = typePlatforms.data.data.bank_id;
          self.listChannel(self.typeid);
          self.listbankchannel(typePlatforms.data.data.bank_id);
          if (!(self.showAmountInput === true || self.channelsfilter.length > 1)) {
            self.check();
          }
        }
      } else if (self.typeoption.length > 1) {
        self.typeid = self.typeoption[0]['key'];
        self.listChannel(self.typeid);
        if (isNeedBank(self.typeid)) {
          self.listbankchannel(self.banksfilter[0]['key']);
          self.bank_key = self.banksfilter[0]['key'];
        }
      }
    });

    sessionStorage.setItem('prev', this.$route.fullPath);
  },

  methods: {
    checkDepositExists: function checkDepositExists(orderInfo) {

      if (orderInfo === undefined || orderInfo === '') {
        this.$router.replace({
          path: '/error',
          query: {
            title: 'Đơn hàng không tồn tại',
            description1: 'Lỗi'
          }
        });
      }

      var hasDeposit = orderInfo.has_deposit,
          appOrderNumber = orderInfo.app_order_no;

      if (hasDeposit) {
        this.$router.replace({
          path: '/error',
          query: {
            title: 'Đơn hàng đã tồn tại',
            description1: '\u0110\u1EB7t h\xE0ng\uFF1A' + appOrderNumber
          }
        });
      }
    },
    handleOrientationChange: function handleOrientationChange() {
      var isRotate = window.screen.orientation && window.screen.orientation.angle > 0 || !window.matchMedia('(orientation: portrait)').matches;

      this.orientpos = /Android|iPhone|iPad|iPod|iOS|BlackBerry|IEMobile/i.test(navigator.userAgent) ? isRotate : false;
    },
    closeIt: function closeIt() {
      this.orientpos = false;
    },
    helpcenter: function helpcenter() {
      this.videoon = true;
      this.videooff = false;
    },
    backtomain: function backtomain() {
      this.videoon = false;
      this.videooff = true;
    },
    closevid: function closevid() {
      var video = document.getElementById('videoinfo');
      video.removeAttribute('src');
      this.popvid = false;
    },
    viewvideo: function viewvideo(videoname) {
      this.popvid = true;
      setTimeout(function () {
        var video = document.getElementById('videoinfo');
        video.setAttribute('type', 'video/mp4');
        video.setAttribute('src', 'static/images/helpcenter/' + videoname + '.mp4');
        video.load();
        video.play();
      }, 500);
    },
    listChannel: function listChannel(typeid) {
      this.typeid = typeid;
      if (!isNeedBank(typeid)) {
        this.showChannel = true;
        this.channel_key = null;
        this.bank_key = null;
        this.channelsfilter = [];
        this.showBank = false;
        this.banksfilter = [];
        this.channelmin = null;
        this.channelmax = null;
        this.success_rate = null;
        this.showTypeSelect = false;
        this.need_scratchcard = null;
        this.need_name = false;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = get_iterator_default()(this.channels), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var channelshow = _step5.value;

            if (typeid === channelshow.type_id) {
              this.channelsfilter = this.channelsfilter.concat(channelshow);
              if (channelshow.default_show) {
                this.channel_key = channelshow.key;
                this.channelmin = channelshow.min_load;
                this.channelmax = channelshow.max_load;
                this.needBank = channelshow.need_bank;
                this.channeldesc = channelshow.description;
                this.need_scratchcard = channelshow.need_scratchcard;
                this.success_rate = channelshow.success_rate;
                this.need_name = channelshow.need_name;
              } else {
                this.channel_key = this.channelsfilter[0]['key'];
                this.channelmin = this.channelsfilter[0]['min_load'];
                this.channelmax = this.channelsfilter[0]['max_load'];
                this.needBank = this.channelsfilter[0]['need_bank'];
                this.channeldesc = this.channelsfilter[0]['description'];
                this.need_scratchcard = this.channelsfilter[0]['need_scratchcard'];
                this.success_rate = this.channelsfilter[0]['success_rate'];
                this.need_name = this.channelsfilter[0]['need_name'];
              }
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      } else {
        this.showBank = false;
        this.banksfilter = [];
        if (typeid === 14) {
          this.titlechoose = 'Chọn loại thẻ';
          this.handleLoadCardTypeSelect();
        } else {
          this.titlechoose = 'Chọn ngân hàng';
          this.showTypeSelect = false;
          this.code = null;
          this.serial = null;
        }
        if (this.havebankid === false) {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(this.banksoption), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var bankshow = _step6.value;

              if (typeid === bankshow.type_id) {
                this.banksfilter = this.banksfilter.concat(bankshow);
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }

          this.bank_key = this.banksfilter[0]['key'];
          this.listbankchannel(this.bank_key);
        } else {
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = get_iterator_default()(this.banksoption), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _bankshow = _step7.value;

              if (typeid === _bankshow.type_id && this.bank_key === _bankshow.key) {
                this.banksfilter = this.banksfilter.concat(_bankshow);
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
        this.showBank = true;
        this.showChannel = true;
      }
    },
    listbankchannel: function listbankchannel(bankkey) {
      this.showChannel = false;
      this.channel_key = null;
      this.channelsfilter = [];
      this.channelmin = null;
      this.channelmax = null;
      this.needBank = null;
      this.need_scratchcard = null;
      this.success_rate = null;
      this.need_name = false;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(this.channels), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var bankchannelshow = _step8.value;

          if (bankchannelshow.type_id === this.typeid && bankchannelshow.related_bankid === bankkey) {
            this.channelsfilter = this.channelsfilter.concat(bankchannelshow);
            if (bankchannelshow.default_show) {
              this.channel_key = bankchannelshow.key;
              this.channelmin = bankchannelshow.min_load;
              this.channelmax = bankchannelshow.max_load;
              this.needBank = bankchannelshow.need_bank;
              this.channeldesc = bankchannelshow.description;
              this.need_scratchcard = bankchannelshow.need_scratchcard;
              this.success_rate = bankchannelshow.success_rate;
              this.need_name = bankchannelshow.need_name;
            } else {
              this.channel_key = this.channelsfilter[0]['key'];
              this.channelmin = this.channelsfilter[0]['min_load'];
              this.channelmax = this.channelsfilter[0]['max_load'];
              this.needBank = this.channelsfilter[0]['need_bank'];
              this.channeldesc = this.channelsfilter[0]['description'];
              this.need_scratchcard = this.channelsfilter[0]['need_scratchcard'];
              this.success_rate = this.channelsfilter[0]['success_rate'];
              this.need_name = this.channelsfilter[0]['need_name'];
            }
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      if (bankkey !== null) {
        this.showChannel = true;
      }
    },
    channelselect: function channelselect(channelkey) {
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = get_iterator_default()(this.channels), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var selectchannel = _step9.value;

          if (this.bank_key === null) {
            if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key) {
              this.channelmin = selectchannel.min_load;
              this.channelmax = selectchannel.max_load;
              this.needBank = selectchannel.need_bank;
              this.channeldesc = selectchannel.description;
              this.need_scratchcard = selectchannel.need_scratchcard;
              this.success_rate = selectchannel.success_rate;
              this.need_name = selectchannel.need_name;
            }
          } else {
            if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key && this.bank_key === selectchannel.related_bankid) {
              this.channelmin = selectchannel.min_load;
              this.channelmax = selectchannel.max_load;
              this.needBank = selectchannel.need_bank;
              this.channeldesc = selectchannel.description;
              this.need_scratchcard = selectchannel.need_scratchcard;
              this.success_rate = selectchannel.success_rate;
              this.need_name = selectchannel.need_name;
              this.handleLoadCardTypeSelect();
            }
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    },
    check: function check() {
      this.$vux.loading.show({
        text: 'Loading'
      });
      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.channelmin;
      var maxLoad = this.channelmax;
      if (this.bank_key === null && (this.typeid === 12 || this.typeid === 13)) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng chọn ngân hàng！',
          'type': 'warn'
        });
        return;
      }

      if (this.bank_key === null && this.typeid === 14) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng chọn loại thẻ！',
          'type': 'warn'
        });
        return;
      }
      if (this.showTypeSelect === true && (this.code === null || this.code.trim() === '' || this.serial === null || this.serial.trim() === '')) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng nhập Mã thẻ và số seri！',
          'type': 'warn'
        });
        return;
      }

      if (this.need_name && this.name === '') {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng nhập tên thật！',
          'type': 'warn'
        });
        return;
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        this.submit(submitAmout);
      } else {
        this.$vux.loading.hide();
        this.$vux.alert.show({
          content: 'Hỗ trợ nạp tiền ' + minLoad + 'VND ~ ' + maxLoad + ' VND '
        });
      }
    },
    generalDepositCreateParams: function generalDepositCreateParams(amount) {
      var self = this;
      return {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.channel_key,
        bank_id: self.bank_key,
        name: self.name,
        amount: amount,
        bank_card_no: self.bank_card_no
      };
    },
    vinaPhoneCardDepositCreateParams: function vinaPhoneCardDepositCreateParams(amount) {
      var self = this;
      return {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.channel_key,
        bank_id: self.bank_key,
        name: self.name,
        amount: amount,
        serial: self.serial,
        code: self.code,
        type: self.bank_key
      };
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;
      var params = this.need_scratchcard ? this.vinaPhoneCardDepositCreateParams(submitAmout) : this.generalDepositCreateParams(submitAmout);

      self.$models.Deposit.create(params).then(function (response) {
        self.pay_click = false;
        if (!response.data.success) {
          self.$vux.loading.hide();
          self.$router.replace({
            path: '/error',
            query: {
              title: response.data.message,
              description1: 'Đặt hàng：' + self.app_order_no,
              description2: 'Kênh số：#' + self.channel_key,
              description3: ''
            }
          });
          return;
        }
        cookie["a" /* default */].remove('historys');
        self.load_url = response.data.data.load_url;
        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          return;
        } else if (response.data.data.load_straight === 2) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url,
              deposit_type: response.data.data.deposit_type,
              platform_id: self.channel_key,
              from_url: self.$route.path
            }
          });
          return;
        }
        if (self.need_scratchcard && self.typeid === 14) {
          self.$router.replace({ path: '/finished' });
          return;
        }

        self.showPayPage = true;
        setTimeout(function () {
          self.$vux.loading.hide();
        }, 2000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: 'Vui lòng hoàn tất thanh toán trong cửa sổ mở mới<br />Nếu đã hoàn tất, hãy nhấp vào "hoàn tất thanh toán"',
        confirmText: 'Hoàn tất thanh toán',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: 'Đơn đặt hàng được bắt đầu quá thường xuyên',
              description1: 'Xin lỗi vì bạn thường xuyên đặt hàng nhưng không gửi thanh toán',
              description2: 'Xin vui lòng mất năm phút nghỉ để thử lại, cảm ơn bạn đã hợp tác của bạn'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
        console.log(historys);
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },

    numberWithCommas: numberWithCommas,
    handleLoadCardTypeSelect: function handleLoadCardTypeSelect() {
      this.code = null;
      this.serial = null;
      this.showTypeSelect = this.typeid === 14 && this.need_scratchcard === 1;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Deposit2Dark.vue




















/* harmony default export */ var components_Deposit2Dark = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Loading: loading["a" /* default */]
  },
  beforeCreate: function beforeCreate() {
    document.body.className = 'charge deposit2 dark';
  },
  data: function data() {
    return {
      typeoption: [],
      typeid: null,
      channels: [],
      channelsfilter: [],
      channel_key: null,
      showChannel: false,
      banksoption: [],
      banksfilter: [],
      bank_key: null,
      needBank: null,
      showBank: false,
      havebankid: false,
      titlechoose: 'Chọn ngân hàng',
      channeldesc: '',
      channelmin: null,
      success_rate: null,
      channelmax: null,
      orientpos: false,
      rotate: false,
      query: '',
      title: '充值',
      platform_show: {
        desc: ''
      },
      amount: 0,
      name: '',
      amount_index: -1,
      input_amount: '',
      confirm: {
        show: false
      },
      showTypeSelect: false,
      code: null,
      serial: null,
      need_bank: null,
      need_scratchcard: 0,
      bank_id: null,
      showPayPage: false,
      load_url: '',
      qrcode: null,
      info: {
        nickname: '',
        usable_gold: '',
        freeze_gold: '',
        financal: {
          status: 0
        }
      },
      show_list: true,
      pay_click: false,
      showAmountInput: false,
      platform_name: '',
      app_order_no: '',
      order_no: '',
      show_amount: 0,
      bank_card_no: '',
      platform_type: '',
      show_amount_input: true,
      videoon: false,
      videooff: true,
      popvid: false,
      need_name: false
    };
  },

  watch: {
    'platform': function platform(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.checkBank();
      }
    },
    'amount': function amount() {
      if (this.amount > 0) {
        this.input_amount = '';
      }
    },
    'input_amount': function input_amount() {
      if (this.input_amount > 0) {
        this.amount = 0;
      }
    },
    '$route.query.order_no': function $routeQueryOrder_no() {
      window.location.reload();
    }
  },
  mounted: function mounted() {
    this.handleOrientationChange();
    window.addEventListener('orientationchange', this.handleOrientationChange);
    this.checkOrderCounts();
    var self = this;
    self.channel_key = typeof self.$route.query.platform_id === 'undefined' ? 1 : JSON.parse(self.$route.query.platform_id);

    self.$models.Deposit.info({
      order_no: self.$route.query.order_no,
      valid: self.$route.query.valid
    }).then(function (typePlatforms) {
      self.checkDepositExists(typePlatforms.data.data);
      self.rotate = typePlatforms.data.data.rotate_prompt;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(typePlatforms.data.data.types), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var typePlatform = _step.value;

          var typelist = {
            key: typePlatform.type_id,
            value: typePlatform.display_name,
            icon: 'static/images/logo/' + typePlatform.icon + '.png',
            isfeatured: typePlatform.is_featured
          };
          var channellist;
          if (!isNeedBank(typePlatform.type_id)) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = get_iterator_default()(typePlatform.data), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var typemobileshow = _step2.value;

                var showmobile, defaultmobile;
                showmobile = typemobileshow.mobile_show;
                defaultmobile = typemobileshow.mobile_default;
                channellist = {
                  show_view: Boolean(showmobile),
                  default_show: Boolean(defaultmobile),
                  key: typemobileshow.id,
                  value: typemobileshow.name,
                  bank_id: typemobileshow.bank_id,
                  banks: typemobileshow.banks,
                  amount_list: typemobileshow.custom_amounts,
                  description: typemobileshow.description,
                  icon: 'static/images/logo/' + typemobileshow.icon + '.png',
                  max_load: typemobileshow.max_load,
                  min_load: typemobileshow.min_load,
                  need_bank: typemobileshow.need_bank,
                  static_amount: typemobileshow.static_amount,
                  type_id: typemobileshow.type_id,
                  need_scratchcard: typemobileshow.need_scratchcard,
                  success_rate: typemobileshow.success_rate,
                  need_name: typemobileshow.need_name
                };
                self.channels = self.channels.concat(channellist);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            self.typeoption = self.typeoption.concat(typelist);
          } else {
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = get_iterator_default()(typePlatform.data), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _typemobileshow = _step3.value;

                var bankshortname = BANKS[_typemobileshow.icon];
                if (bankshortname === '' || bankshortname === undefined) {
                  bankshortname = _typemobileshow.name;
                }
                var banklist = {
                  key: _typemobileshow.icon,
                  value: bankshortname,
                  icon: 'static/images/vnbanks/icons/' + _typemobileshow.icon + '.png',
                  children: _typemobileshow.children,
                  type_id: typePlatform.type_id
                };
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                  for (var _iterator4 = get_iterator_default()(_typemobileshow.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var typemobileshow2 = _step4.value;

                    showmobile = typemobileshow2.mobile_show;
                    defaultmobile = typemobileshow2.mobile_default;
                    channellist = {
                      show_view: Boolean(showmobile),
                      default_show: Boolean(defaultmobile),
                      key: typemobileshow2.id,
                      value: typemobileshow2.name,
                      bank_id: typemobileshow2.bank_id,
                      banks: typemobileshow2.banks,
                      amount_list: typemobileshow2.custom_amounts,
                      description: typemobileshow2.description,
                      icon: 'static/images/logo/' + typemobileshow2.icon + '.png',
                      max_load: typemobileshow2.max_load,
                      min_load: typemobileshow2.min_load,
                      need_bank: typemobileshow2.need_bank,
                      static_amount: typemobileshow2.static_amount,
                      type_id: typemobileshow2.type_id,
                      related_bankid: _typemobileshow.icon,
                      related_bankname: _typemobileshow.name,
                      need_scratchcard: typemobileshow2.need_scratchcard,
                      success_rate: typemobileshow2.success_rate,
                      need_name: typemobileshow2.need_name
                    };
                    self.channels = self.channels.concat(channellist);
                  }
                } catch (err) {
                  _didIteratorError4 = true;
                  _iteratorError4 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                      _iterator4.return();
                    }
                  } finally {
                    if (_didIteratorError4) {
                      throw _iteratorError4;
                    }
                  }
                }

                self.banksoption = self.banksoption.concat(banklist);
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            self.typeoption = self.typeoption.concat(typelist);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (['', null, '0.00'].includes(typePlatforms.data.data.amount)) {
        self.showAmountInput = true;
      } else {
        self.showAmountInput = false;
        self.show_amount = typePlatforms.data.data.amount;
      }
      self.app_order_no = typePlatforms.data.data.app_order_no;
      if (self.typeoption.length === 0) {
        self.$router.replace({
          path: '/error',
          query: {
            title: 'Ngân hàng này đang bảo trì.<br />Vui lòng quay lại sau.',
            description1: '\u0110\u1EB7t h\xE0ng\uFF1A' + typePlatforms.data.data.app_order_no,
            description2: 'C\xE1c lo\u1EA1i thanh to\xE1n\uFF1A ' + (typePlatforms.data.data.type === null ? 'Không có kênh nào tại thời gian này' : typePlatforms.data.data.type)
          }
        });
      } else if (self.typeoption.length === 1) {
        self.typeid = self.typeoption[0]['key'];
        if (typePlatforms.data.data.bank_id === null) {
          self.havebankid = false;
          self.listChannel(self.typeid);
          if (!(self.showAmountInput === true || isNeedBank(self.typeid) && self.banksfilter.length > 1 || self.channelsfilter.length > 1)) {
            self.check();
          }
        } else {
          self.havebankid = true;
          self.bank_key = typePlatforms.data.data.bank_id;
          self.listChannel(self.typeid);
          self.listbankchannel(typePlatforms.data.data.bank_id);
          if (!(self.showAmountInput === true || self.channelsfilter.length > 1)) {
            self.check();
          }
        }
      } else if (self.typeoption.length > 1) {
        self.typeid = self.typeoption[0]['key'];
        self.listChannel(self.typeid);
        if (isNeedBank(self.typeid)) {
          self.listbankchannel(self.banksfilter[0]['key']);
          self.bank_key = self.banksfilter[0]['key'];
        }
      }
    });

    sessionStorage.setItem('prev', this.$route.fullPath);
  },

  methods: {
    checkDepositExists: function checkDepositExists(orderInfo) {

      if (orderInfo === undefined || orderInfo === '') {
        this.$router.replace({
          path: '/error',
          query: {
            title: 'Đơn hàng không tồn tại',
            description1: 'Lỗi'
          }
        });
      }

      var hasDeposit = orderInfo.has_deposit,
          appOrderNumber = orderInfo.app_order_no;

      if (hasDeposit) {
        this.$router.replace({
          path: '/error',
          query: {
            title: 'Đơn hàng đã tồn tại',
            description1: '\u0110\u1EB7t h\xE0ng\uFF1A' + appOrderNumber
          }
        });
      }
    },
    handleOrientationChange: function handleOrientationChange() {
      var isRotate = window.screen.orientation && window.screen.orientation.angle > 0 || !window.matchMedia('(orientation: portrait)').matches;

      this.orientpos = /Android|iPhone|iPad|iPod|iOS|BlackBerry|IEMobile/i.test(navigator.userAgent) ? isRotate : false;
    },
    closeIt: function closeIt() {
      this.orientpos = false;
    },
    helpcenter: function helpcenter() {
      this.videoon = true;
      this.videooff = false;
    },
    backtomain: function backtomain() {
      this.videoon = false;
      this.videooff = true;
    },
    closevid: function closevid() {
      var video = document.getElementById('videoinfo');
      video.removeAttribute('src');
      this.popvid = false;
    },
    viewvideo: function viewvideo(videoname) {
      this.popvid = true;
      setTimeout(function () {
        var video = document.getElementById('videoinfo');
        video.setAttribute('type', 'video/mp4');
        video.setAttribute('src', 'static/images/helpcenter/' + videoname + '.mp4');
        video.load();
        video.play();
      }, 500);
    },
    listChannel: function listChannel(typeid) {
      this.typeid = typeid;
      if (!isNeedBank(typeid)) {
        this.showChannel = true;
        this.channel_key = null;
        this.bank_key = null;
        this.channelsfilter = [];
        this.showBank = false;
        this.banksfilter = [];
        this.channelmin = null;
        this.channelmax = null;
        this.success_rate = null;
        this.showTypeSelect = false;
        this.need_scratchcard = null;
        this.need_name = false;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = get_iterator_default()(this.channels), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var channelshow = _step5.value;

            if (typeid === channelshow.type_id) {
              this.channelsfilter = this.channelsfilter.concat(channelshow);
              if (channelshow.default_show) {
                this.channel_key = channelshow.key;
                this.channelmin = channelshow.min_load;
                this.channelmax = channelshow.max_load;
                this.needBank = channelshow.need_bank;
                this.channeldesc = channelshow.description;
                this.need_scratchcard = channelshow.need_scratchcard;
                this.success_rate = channelshow.success_rate;
                this.need_name = channelshow.need_name;
              } else {
                this.channel_key = this.channelsfilter[0]['key'];
                this.channelmin = this.channelsfilter[0]['min_load'];
                this.channelmax = this.channelsfilter[0]['max_load'];
                this.needBank = this.channelsfilter[0]['need_bank'];
                this.channeldesc = this.channelsfilter[0]['description'];
                this.need_scratchcard = this.channelsfilter[0]['need_scratchcard'];
                this.success_rate = this.channelsfilter[0]['success_rate'];
                this.need_name = this.channelsfilter[0]['need_name'];
              }
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      } else {
        this.showBank = false;
        this.banksfilter = [];
        if (typeid === 14) {
          this.titlechoose = 'Chọn loại thẻ';
          this.handleLoadCardTypeSelect();
        } else {
          this.titlechoose = 'Chọn ngân hàng';
          this.showTypeSelect = false;
          this.code = null;
          this.serial = null;
        }
        if (this.havebankid === false) {
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = get_iterator_default()(this.banksoption), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var bankshow = _step6.value;

              if (typeid === bankshow.type_id) {
                this.banksfilter = this.banksfilter.concat(bankshow);
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }

          this.bank_key = this.banksfilter[0]['key'];
          this.listbankchannel(this.bank_key);
        } else {
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = get_iterator_default()(this.banksoption), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _bankshow = _step7.value;

              if (typeid === _bankshow.type_id && this.bank_key === _bankshow.key) {
                this.banksfilter = this.banksfilter.concat(_bankshow);
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
        this.showBank = true;
        this.showChannel = true;
      }
    },
    listbankchannel: function listbankchannel(bankkey) {
      this.showChannel = false;
      this.channel_key = null;
      this.channelsfilter = [];
      this.channelmin = null;
      this.channelmax = null;
      this.needBank = null;
      this.need_scratchcard = null;
      this.success_rate = null;
      this.need_name = false;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = get_iterator_default()(this.channels), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var bankchannelshow = _step8.value;

          if (bankchannelshow.type_id === this.typeid && bankchannelshow.related_bankid === bankkey) {
            this.channelsfilter = this.channelsfilter.concat(bankchannelshow);
            if (bankchannelshow.default_show) {
              this.channel_key = bankchannelshow.key;
              this.channelmin = bankchannelshow.min_load;
              this.channelmax = bankchannelshow.max_load;
              this.needBank = bankchannelshow.need_bank;
              this.channeldesc = bankchannelshow.description;
              this.need_scratchcard = bankchannelshow.need_scratchcard;
              this.success_rate = bankchannelshow.success_rate;
              this.need_name = bankchannelshow.need_name;
            } else {
              this.channel_key = this.channelsfilter[0]['key'];
              this.channelmin = this.channelsfilter[0]['min_load'];
              this.channelmax = this.channelsfilter[0]['max_load'];
              this.needBank = this.channelsfilter[0]['need_bank'];
              this.channeldesc = this.channelsfilter[0]['description'];
              this.need_scratchcard = this.channelsfilter[0]['need_scratchcard'];
              this.success_rate = this.channelsfilter[0]['success_rate'];
              this.need_name = this.channelsfilter[0]['need_name'];
            }
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      if (bankkey !== null) {
        this.showChannel = true;
      }
    },
    channelselect: function channelselect(channelkey) {
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = get_iterator_default()(this.channels), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var selectchannel = _step9.value;

          if (this.bank_key === null) {
            if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key) {
              this.channelmin = selectchannel.min_load;
              this.channelmax = selectchannel.max_load;
              this.needBank = selectchannel.need_bank;
              this.channeldesc = selectchannel.description;
              this.need_scratchcard = selectchannel.need_scratchcard;
              this.success_rate = selectchannel.success_rate;
              this.need_name = selectchannel.need_name;
            }
          } else {
            if (this.typeid === selectchannel.type_id && channelkey === selectchannel.key && this.bank_key === selectchannel.related_bankid) {
              this.channelmin = selectchannel.min_load;
              this.channelmax = selectchannel.max_load;
              this.needBank = selectchannel.need_bank;
              this.channeldesc = selectchannel.description;
              this.need_scratchcard = selectchannel.need_scratchcard;
              this.success_rate = selectchannel.success_rate;
              this.need_name = selectchannel.need_name;
              this.handleLoadCardTypeSelect();
            }
          }
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }
    },
    check: function check() {
      this.$vux.loading.show({
        text: 'Loading'
      });
      var submitAmout = Math.max(this.amount, this.input_amount);
      submitAmout = Math.max(this.show_amount, submitAmout);
      var minLoad = this.channelmin;
      var maxLoad = this.channelmax;
      if (this.bank_key === null && (this.typeid === 12 || this.typeid === 13)) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng chọn ngân hàng！',
          'type': 'warn'
        });
        return;
      }

      if (this.bank_key === null && this.typeid === 14) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng chọn loại thẻ！',
          'type': 'warn'
        });
        return;
      }
      if (this.showTypeSelect === true && (this.code === null || this.code.trim() === '' || this.serial === null || this.serial.trim() === '')) {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng nhập Mã thẻ và số seri！',
          'type': 'warn'
        });
        return;
      }

      if (this.need_name && this.name === '') {
        this.$vux.loading.hide();
        this.$vux.toast.show({
          'text': 'Vui lòng nhập tên thật！',
          'type': 'warn'
        });
        return;
      }
      if (submitAmout >= minLoad && submitAmout <= maxLoad) {
        this.submit(submitAmout);
      } else {
        this.$vux.loading.hide();
        this.$vux.alert.show({
          content: 'Hỗ trợ nạp tiền ' + minLoad + 'VND ~ ' + maxLoad + ' VND '
        });
      }
    },
    generalDepositCreateParams: function generalDepositCreateParams(amount) {
      var self = this;
      return {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.channel_key,
        bank_id: self.bank_key,
        name: self.name,
        amount: amount,
        bank_card_no: self.bank_card_no
      };
    },
    vinaPhoneCardDepositCreateParams: function vinaPhoneCardDepositCreateParams(amount) {
      var self = this;
      return {
        order_no: self.$route.query.order_no,
        valid: self.$route.query.valid,
        platform_id: self.channel_key,
        bank_id: self.bank_key,
        name: self.name,
        amount: amount,
        serial: self.serial,
        code: self.code,
        type: self.bank_key
      };
    },
    submit: function submit(submitAmout) {
      var self = this;
      self.pay_click = true;
      var params = this.need_scratchcard ? this.vinaPhoneCardDepositCreateParams(submitAmout) : this.generalDepositCreateParams(submitAmout);

      self.$models.Deposit.create(params).then(function (response) {
        self.pay_click = false;
        if (!response.data.success) {
          self.$vux.loading.hide();
          self.$router.replace({
            path: '/error',
            query: {
              title: response.data.message,
              description1: 'Đặt hàng：' + self.app_order_no,
              description2: 'Kênh số：#' + self.channel_key,
              description3: ''
            }
          });
          return;
        }
        cookie["a" /* default */].remove('historys');
        self.load_url = response.data.data.load_url;
        if (response.data.data.load_straight === 1) {
          window.location.href = self.load_url;
          return;
        } else if (response.data.data.load_straight === 2) {
          self.$router.replace({
            path: './qrcode',
            query: {
              qrcode: response.data.data.load_url,
              deposit_type: response.data.data.deposit_type,
              platform_id: self.channel_key,
              from_url: self.$route.path
            }
          });
          return;
        }
        if (self.need_scratchcard && self.typeid === 14) {
          self.$router.replace({ path: '/finished' });
          return;
        }

        self.showPayPage = true;
        setTimeout(function () {
          self.$vux.loading.hide();
        }, 2000);
      });
    },
    showAsk: function showAsk() {
      var self = this;
      self.$vux.confirm.show({
        content: 'Vui lòng hoàn tất thanh toán trong cửa sổ mở mới<br />Nếu đã hoàn tất, hãy nhấp vào "hoàn tất thanh toán"',
        confirmText: 'Hoàn tất thanh toán',

        onCancel: function onCancel() {},
        onConfirm: function onConfirm() {
          self.payComplete();
        }
      });
    },
    showContent: function showContent(platform) {
      var self = this;
      if (platform.show) {
        self.show_list = false;
        switch (platform.show.type) {
          case 'qr':
            self.showQrCode(platform);
            break;
          case 'url':
            self.showUrl(platform);
            break;
        }
      } else {
        self.show_list = true;
      }
    },
    showQrCode: function showQrCode(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    showUrl: function showUrl(platform) {
      var self = this;
      self.platform_show = platform.show;
    },
    navToPay: function navToPay() {
      var self = this;
      window.location.href = self.platform_show.link;
    },
    payComplete: function payComplete() {
      var self = this;
      self.showPayPage = false;
      self.$router.replace({
        path: '/deposit/list'
      });
    },
    checkOrderCounts: function checkOrderCounts() {
      var history = cookie["a" /* default */].get('historys');
      if (typeof history !== 'undefined') {
        console.log('historys in 5mins count:' + keys_default()(JSON.parse(history)).length);
        if (keys_default()(JSON.parse(history)).length > 50) {
          this.$router.replace({
            path: '/error',
            query: {
              title: 'Đơn đặt hàng được bắt đầu quá thường xuyên',
              description1: 'Xin lỗi vì bạn thường xuyên đặt hàng nhưng không gửi thanh toán',
              description2: 'Xin vui lòng mất năm phút nghỉ để thử lại, cảm ơn bạn đã hợp tác của bạn'
            }
          });
          return false;
        }
      }

      if (typeof this.$route.query.order_no !== 'undefined') {
        this.setOrderCounts();
      }
    },
    setOrderCounts: function setOrderCounts() {
      var historys = {};
      if (typeof cookie["a" /* default */].get('historys') !== 'undefined') {
        historys = JSON.parse(cookie["a" /* default */].get('historys'));
        console.log(historys);
      }

      historys[this.$route.query.order_no] = true;

      var expire = new Date();
      expire.setMinutes(expire.getMinutes() + 5);
      cookie["a" /* default */].set('historys', stringify_default()(historys), {
        expires: expire,
        raw: true
      });
    },

    numberWithCommas: numberWithCommas,
    handleLoadCardTypeSelect: function handleLoadCardTypeSelect() {
      this.code = null;
      this.serial = null;
      this.showTypeSelect = this.typeid === 14 && this.need_scratchcard === 1;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2813561c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Deposit2Dark.vue
var Deposit2Dark_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-add cssoverwrite",staticStyle:{"height":"100%"}},[_vm._m(0),_vm._v(" "),(_vm.videooff)?_c('div',[_c('view-box',{attrs:{"body-padding-top":"0px","body-padding-bottom":"0px"}},[_c('template',{slot:"default"},[_c('div',{staticClass:"left-con",class:{'oneonly':_vm.typeoption.length == 1}},[_c('div',{staticClass:"typecon"},[_c('radio',{attrs:{"options":_vm.typeoption},on:{"on-change":_vm.listChannel},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('div',{staticClass:"type-icon"},[_c('img',{attrs:{"width":"38","src":props.icon}})]),_vm._v(" "),_c('div',{staticClass:"type-label"},[_vm._v(_vm._s(props.label))]),_vm._v(" "),( _vm.typeoption[props.index].isfeatured)?_c('div',{staticClass:"featuredtype"},[_c('img',{attrs:{"src":"static/images/ui/deposit/reco-mobile.png","alt":""}})]):_vm._e()]}}],null,false,2571710570),model:{value:(_vm.typeid),callback:function ($$v) {_vm.typeid=$$v},expression:"typeid"}})],1)]),_vm._v(" "),_c('div',{staticClass:"right-con",class:{'oneonly':_vm.typeoption.length == 1}},[(_vm.showAmountInput == false)?_c('div',{staticClass:"amount-con"},[_c('x-input',{attrs:{"title":"Số tiền ","disabled":true,"value":'đ '+ _vm.numberWithCommas(_vm.show_amount)}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"orderno-con landscapecon",class:{'fullwidth': _vm.showAmountInput == true}},[_c('x-input',{attrs:{"disabled":true,"value":'Mã giao dịch    '+_vm.app_order_no,"text-align":"right"}})],1),_vm._v(" "),_c('div',{staticClass:"orderno-con portraitcon",class:{'fullwidth': _vm.showAmountInput == true}},[_c('x-input',{attrs:{"disabled":true,"title":"Mã giao dịch","value":_vm.app_order_no,"text-align":"right"}})],1),_vm._v(" "),_c('group',{staticClass:"linecon",attrs:{"gutter":"10px"}},[(_vm.showBank)?_c('group',{staticClass:"bankdisplay",attrs:{"gutter":"0px"}},[_c('div',{staticClass:"banktitle"},[_vm._v(_vm._s(_vm.titlechoose))]),_vm._v(" "),_c('radio',{attrs:{"options":_vm.banksfilter},on:{"on-change":_vm.listbankchannel},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('p',{staticStyle:{"line-height":"40px","display":"table"}},[_c('span',{staticStyle:{"display":"table-cell","vertical-align":"middle"}},[_c('img',{staticClass:"rmargin-20px",staticStyle:{"margin-right":"10px","vertical-align":"middle"},attrs:{"width":"40","src":props.icon}})]),_vm._v(" "),_c('span',{class:{'lineheightadjust':props.label == 'Vietnam Mobile'},staticStyle:{"display":"table-cell","line-height":"18px","vertical-align":"middle","font-size":"15px"}},[_vm._v(_vm._s(props.label))])])]}}],null,false,3537741527),model:{value:(_vm.bank_key),callback:function ($$v) {_vm.bank_key=$$v},expression:"bank_key"}})],1):_vm._e(),_vm._v(" "),(_vm.showChannel)?_c('group',{attrs:{"gutter":"0px"}},[_c('div',{staticClass:"channeltitle"},[_vm._v("Chọn kênh")]),_vm._v(" "),_c('div',{staticClass:"channeldropdown"},[_c('popup-radio',{class:{'onechan':_vm.channelsfilter.length == 1},attrs:{"options":_vm.channelsfilter,"id":_vm.channelsfilter[0].icon.substring(19,_vm.channelsfilter[0].icon.length-4),"readonly":_vm.channelsfilter.length == 1},on:{"on-change":_vm.channelselect},scopedSlots:_vm._u([{key:"each-item",fn:function(props){return [_c('div',{staticClass:"channelpop"},[_c('div',{staticClass:"channel-icon"},[_c('img',{attrs:{"width":"40","src":props.icon}})]),_vm._v(" "),_c('div',{staticClass:"channel-label"},[_c('div',{staticClass:"labelchannel"},[_vm._v(_vm._s(props.label))]),_vm._v(" "),_c('div',{staticClass:"channelrange"},[_vm._v(_vm._s(_vm.numberWithCommas(_vm.channelsfilter[props.index].min_load))+"-"+_vm._s(_vm.numberWithCommas(_vm.channelsfilter[props.index].max_load))+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"succrate"},[_c('div',{staticClass:"c100 green",class:_vm.channelsfilter[props.index].success_rate > 60 ? 'green p'+ parseInt(_vm.channelsfilter[props.index].success_rate): 'yellow p' + parseInt(_vm.channelsfilter[props.index].success_rate)},[_c('span',[_vm._v(_vm._s(_vm.channelsfilter[props.index].success_rate + '%'))]),_vm._v(" "),_c('div',{staticClass:"slice"},[_c('div',{staticClass:"bar"}),_vm._v(" "),_c('div',{staticClass:"fill"})])])])])]}}],null,false,3674916823),model:{value:(_vm.channel_key),callback:function ($$v) {_vm.channel_key=$$v},expression:"channel_key"}})],1)]):_vm._e(),_vm._v(" "),(_vm.showTypeSelect)?_c('div',{staticClass:"vinaphonecon"},[_c('group',{attrs:{"gutter":"0"}},[_c('x-input',{staticClass:"x-input-default",attrs:{"type":"text","placeholder":"Mã thẻ","text-align":"left"},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}),_vm._v(" "),_c('x-input',{staticClass:"x-input-default",attrs:{"type":"text","placeholder":"Số seri","text-align":"left"},model:{value:(_vm.serial),callback:function ($$v) {_vm.serial=$$v},expression:"serial"}})],1)],1):_vm._e(),_vm._v(" "),_c('group',{attrs:{"gutter":"0"}},[(_vm.need_name)?_c('x-input',{staticClass:"x-input-default",attrs:{"type":"text","placeholder":"tên người trả tiền","text-align":"left"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}):_vm._e()],1),_vm._v(" "),(_vm.showAmountInput)?_c('div',{staticClass:"showamountcon"},[_c('group',{attrs:{"gutter":"0","title":'Tối thiểu ' + _vm.channelmin + ' VND Cao nhất ' + _vm.channelmax + ' VND'}},[(_vm.show_amount_input)?_c('x-input',{attrs:{"title":_vm.input_amount * 1 + ' Tách rời',"type":"tel","placeholder":"Nhập một khoản tiền tùy chỉnh","text-align":"right","max":9},model:{value:(_vm.input_amount),callback:function ($$v) {_vm.input_amount=$$v},expression:"input_amount"}}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('box',{attrs:{"gap":"15px 15px 15px 15px"}},[_c('x-button',{attrs:{"type":"primary","disabled":_vm.pay_click},nativeOn:{"click":function($event){return _vm.check.apply(null, arguments)}}},[_vm._v("Thanh toán ngay")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"font-size":"0.8em","padding":"10px 0px","text-align":"left"}},[_c('p',[_vm._v(_vm._s(_vm.channeldesc))])])],1),_vm._v(" "),_c('popup',{attrs:{"height":"100%"},on:{"on-hide":_vm.showAsk},model:{value:(_vm.showPayPage),callback:function ($$v) {_vm.showPayPage=$$v},expression:"showPayPage"}},[_c('view-box',{staticStyle:{"height":"100%"},attrs:{"slot":"default","body-padding-top":"50px","body-padding-bottom":"0"},slot:"default"},[_c('x-button',{staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0","z-index":"100","border-radius":"0","height":"58px"},attrs:{"slot":"header","text":"完成","type":"primary"},nativeOn:{"click":function($event){_vm.showPayPage = false}},slot:"header"}),_vm._v(" "),(_vm.showPayPage)?_c('iframe',{staticStyle:{"position":"absolute","border":"none","top":"50px"},attrs:{"src":_vm.load_url,"width":"100%","height":"100%"}}):_vm._e()],1)],1)],1)],2)],1):_vm._e(),_vm._v(" "),(_vm.videoon)?_c('div',{staticClass:"videoPage"},[_c('div',{staticClass:"backicon",on:{"click":_vm.backtomain}},[_c('img',{attrs:{"src":"static/images/helpcenter/back-icon.png"}})]),_vm._v(" "),_c('div',{staticClass:"videoheader"},[_vm._v("TRUNG TÂM TRỢ GIÚP")]),_vm._v(" "),_c('div',{staticClass:"videocon"},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.viewvideo('banktransfer')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-bank.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('onlinebank')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-onlinebank.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('momo')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-momo.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('viettel')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-viettel.jpg"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.viewvideo('zalo')}}},[_c('img',{attrs:{"src":"static/images/helpcenter/thumbnail-zalo.jpg"}})])])]),_vm._v(" "),(_vm.popvid)?_c('div',{staticClass:"videobg"},[_c('div',{staticClass:"videoplayercon"},[_c('video',{attrs:{"src":"","id":"videoinfo","controls":""}}),_vm._v(" "),_c('div',{staticClass:"closebtn",on:{"click":_vm.closevid}},[_c('img',{attrs:{"src":"static/images/helpcenter/closebtn.png"}})])])]):_vm._e()]):_vm._e()])}
var Deposit2Dark_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"helpicon"},[_c('a',{attrs:{"href":"https://www.1bestpay.com/helpcenter","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{attrs:{"src":"static/images/helpcenter/help-center-icon.png"}})])])}]
var Deposit2Dark_esExports = { render: Deposit2Dark_render, staticRenderFns: Deposit2Dark_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_Deposit2Dark = (Deposit2Dark_esExports);
// CONCATENATED MODULE: ./src/components/Deposit2Dark.vue
var Deposit2Dark_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Deposit2Dark___vue_template_functional__ = false
/* styles */
var Deposit2Dark___vue_styles__ = null
/* scopeId */
var Deposit2Dark___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Deposit2Dark___vue_module_identifier__ = null
var Deposit2Dark_Component = Deposit2Dark_normalizeComponent(
  components_Deposit2Dark,
  selectortype_template_index_0_src_components_Deposit2Dark,
  Deposit2Dark___vue_template_functional__,
  Deposit2Dark___vue_styles__,
  Deposit2Dark___vue_scopeId__,
  Deposit2Dark___vue_module_identifier__
)

/* harmony default export */ var src_components_Deposit2Dark = (Deposit2Dark_Component.exports);

// CONCATENATED MODULE: ./src/models/models/Deposit.js
/**
 * Created by roger.s on 2017/7/4.
 */



/* harmony default export */ var models_Deposit = ({
  info: function info(params) {
    return vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.serverUrl + 'deposit/info', {
      params: params
    });
  },
  create: function create(params) {
    return vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.serverUrl + 'deposit/create', {
      params: params
    });
  }
});
// CONCATENATED MODULE: ./src/models/models/Pay.js


/* harmony default export */ var Pay = ({
  info: function info(params) {
    return vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.serverUrl + 'pay/info', {
      params: params
    });
  },
  create: function create(params) {
    return vue_esm["a" /* default */].http.get(vue_esm["a" /* default */].prototype.serverUrl + 'pay/create', {
      params: params
    });
  }
});
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// CONCATENATED MODULE: ./src/models/index.js





vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);

var serverUrl = '/api/';
if (window.location.host === 'localhost:8081' || window.location.host === 'localhost:8080') {
  serverUrl = 'http://localhost/api/';
}

var models = {
  Deposit: models_Deposit,
  Pay: Pay
};
/* harmony default export */ var src_models = ({
  install: function install(Vue) {
    Vue.prototype.$models = models;
    Vue.models = models;
    Vue.prototype.serverUrl = serverUrl;
  },

  $models: models
});

var $models = models;
// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var components_selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var components_selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: components_selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0012d80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/selector/index.vue
var selector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-selector weui-cell",class:{
    'weui-cell_select': !_vm.readonly,
    'weui-cell_select-after': _vm.title
  }},[(_vm.title)?_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.cleanStyle({
        width: _vm.$parent.labelWidth,
        textAlign: _vm.$parent.labelAlign,
        marginRight: _vm.$parent.labelMarginRight
      })),attrs:{"for":("vux-selector-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_vm._v(" "),(!_vm.readonly)?_c('div',{staticClass:"weui-cell__bd"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-select",style:(_vm.cleanStyle({
        direction: _vm.direction,
        color: _vm.color
      })),attrs:{"id":("vux-selector-" + _vm.uuid),"name":_vm.name},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[(_vm.showPlaceholder)?_c('option',{domProps:{"value":_vm.value === null ? 'null' : '',"selected":_vm.isEmptyValue(_vm.value) && !!_vm.placeholder}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.fixIos)?_c('option',{attrs:{"disabled":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.processOptions),function(one){return _c('option',{domProps:{"value":one.key}},[_vm._v(_vm._s(_vm.direction === 'rtl' ? one.value + '‎' : one.value))])})],2)]):_c('div',{staticClass:"weui-cell__ft vux-selector-readonly"},[_vm._v("\n    "+_vm._s(_vm._f("findByKey")(_vm.value,_vm.processOptions))+"\n  ")])])}
var selector_staticRenderFns = []
var selector_esExports = { render: selector_render, staticRenderFns: selector_staticRenderFns }
/* harmony default export */ var src_components_selector = (selector_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/selector/index.vue
function selector_injectStyle (ssrContext) {
  __webpack_require__("B81l")
}
var selector_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var selector___vue_template_functional__ = false
/* styles */
var selector___vue_styles__ = selector_injectStyle
/* scopeId */
var selector___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var selector___vue_module_identifier__ = null
var selector_Component = selector_normalizeComponent(
  components_selector,
  src_components_selector,
  selector___vue_template_functional__,
  selector___vue_styles__,
  selector___vue_scopeId__,
  selector___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_selector = (selector_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UserInfo.vue














/* harmony default export */ var UserInfo = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Loading: loading["a" /* default */],
    Selector: vux_src_components_selector
  },
  beforeCreate: function beforeCreate() {
    document.body.className = 'userinfo';
  },
  data: function data() {
    return {
      original: {
        name: ''
      },
      custom: {
        name: ''
      },
      submitButton: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$models.Pay.info({
      order_no: this.$route.query.order_no,
      valid: this.$route.query.valid
    }).then(function (_ref) {
      var _ref$data = _ref.data,
          success = _ref$data.success,
          data = _ref$data.data,
          message = _ref$data.message;

      if (!success) {
        _this.$router.replace({
          path: '/error',
          query: {
            title: 'Lỗi hệ thống',
            description1: message
          }
        });
        return false;
      }
    });
  },

  methods: {
    preparedCreateParams: function preparedCreateParams() {
      return {
        order_no: this.$route.query.order_no,
        valid: this.$route.query.valid,
        name: this.custom.name
      };
    },
    check: function check() {
      if (this.original.name === this.custom.name) {
        this.$vux.toast.show({
          'text': 'Vui lòng điền thông tin!',
          'type': 'warn'
        });
        return;
      }

      this.submit();
    },
    submit: function submit() {
      var _this2 = this;

      this.$vux.loading.show();
      this.submitButton = true;
      var params = this.preparedCreateParams();
      this.$models.Pay.create(params).then(function (_ref2) {
        var _ref2$data = _ref2.data,
            success = _ref2$data.success,
            data = _ref2$data.data,
            message = _ref2$data.message;

        if (!success) {
          _this2.$vux.loading.hide();
          _this2.$router.replace({
            path: '/error',
            query: {
              title: 'Lỗi hệ thống',
              description1: 'Lỗi hệ thống'
            }
          });
        } else {
          window.location.replace(data.load_url);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UserInfo.vue














/* harmony default export */ var components_UserInfo = ({
  components: {
    Group: vux_src_components_group,
    Cell: vux_src_components_cell,
    ViewBox: vux_src_components_view_box,
    XHeader: vux_src_components_x_header,
    XButton: vux_src_components_x_button,
    Box: vux_src_components_box,
    XInput: vux_src_components_x_input,
    PopupRadio: vux_src_components_popup_radio,
    Popup: node_modules_vux_src_components_popup,
    Radio: node_modules_vux_src_components_radio,
    Loading: loading["a" /* default */],
    Selector: vux_src_components_selector
  },
  beforeCreate: function beforeCreate() {
    document.body.className = 'userinfo';
  },
  data: function data() {
    return {
      original: {
        name: ''
      },
      custom: {
        name: ''
      },
      submitButton: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$models.Pay.info({
      order_no: this.$route.query.order_no,
      valid: this.$route.query.valid
    }).then(function (_ref) {
      var _ref$data = _ref.data,
          success = _ref$data.success,
          data = _ref$data.data,
          message = _ref$data.message;

      if (!success) {
        _this.$router.replace({
          path: '/error',
          query: {
            title: 'Lỗi hệ thống',
            description1: message
          }
        });
        return false;
      }
    });
  },

  methods: {
    preparedCreateParams: function preparedCreateParams() {
      return {
        order_no: this.$route.query.order_no,
        valid: this.$route.query.valid,
        name: this.custom.name
      };
    },
    check: function check() {
      if (this.original.name === this.custom.name) {
        this.$vux.toast.show({
          'text': 'Vui lòng điền thông tin!',
          'type': 'warn'
        });
        return;
      }

      this.submit();
    },
    submit: function submit() {
      var _this2 = this;

      this.$vux.loading.show();
      this.submitButton = true;
      var params = this.preparedCreateParams();
      this.$models.Pay.create(params).then(function (_ref2) {
        var _ref2$data = _ref2.data,
            success = _ref2$data.success,
            data = _ref2$data.data,
            message = _ref2$data.message;

        if (!success) {
          _this2.$vux.loading.hide();
          _this2.$router.replace({
            path: '/error',
            query: {
              title: 'Lỗi hệ thống',
              description1: 'Lỗi hệ thống'
            }
          });
        } else {
          window.location.replace(data.load_url);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85b96f50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserInfo.vue
var UserInfo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-info cssoverwrite",staticStyle:{"height":"100%"}},[_c('view-box',{attrs:{"body-padding-top":"50px","body-padding-bottom":"51px"}},[_c('template',{slot:"default"},[_c('div',[_c('group',{staticClass:"accountname-con",attrs:{"gutter":"0"}},[_c('div',{staticClass:"accountnametitle"},[_c('b',[_vm._v("Tên người thanh toán")])]),_vm._v(" "),_c('x-input',{staticClass:"x-input-default",attrs:{"placeholder":"Vui lòng điền tên người thanh toán","type":"text"},model:{value:(_vm.custom.name),callback:function ($$v) {_vm.$set(_vm.custom, "name", $$v)},expression:"custom.name"}})],1),_vm._v(" "),_c('group',{staticClass:"note-con",attrs:{"gutter":"0"}},[_c('div',{staticClass:"rednote"},[_vm._v("🔔🔔Tên người thanh toán phải trùng với tên thẻ ngân hàng dùng để thanh toán🔔🔔")])]),_vm._v(" "),_c('box',{attrs:{"gap":"50px 15px 15px 15px"}},[_c('x-button',{attrs:{"type":"primary","disabled":_vm.submitButton},nativeOn:{"click":function($event){return _vm.check.apply(null, arguments)}}},[_vm._v("Thanh toán ngay!")])],1)],1),_vm._v(" "),_c('p',{staticClass:"copy-right"},[_vm._v("© PayNow")])])],2)],1)}
var UserInfo_staticRenderFns = []
var UserInfo_esExports = { render: UserInfo_render, staticRenderFns: UserInfo_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_UserInfo = (UserInfo_esExports);
// CONCATENATED MODULE: ./src/components/UserInfo.vue
var UserInfo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UserInfo___vue_template_functional__ = false
/* styles */
var UserInfo___vue_styles__ = null
/* scopeId */
var UserInfo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserInfo___vue_module_identifier__ = null
var UserInfo_Component = UserInfo_normalizeComponent(
  components_UserInfo,
  selectortype_template_index_0_src_components_UserInfo,
  UserInfo___vue_template_functional__,
  UserInfo___vue_styles__,
  UserInfo___vue_scopeId__,
  UserInfo___vue_module_identifier__
)

/* harmony default export */ var src_components_UserInfo = (UserInfo_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/ajax/index.js
var ajax = __webpack_require__("yD8N");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var plugins_toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var plugins_loading = __webpack_require__("Y+qm");

// CONCATENATED MODULE: ./src/main.js
























vue_esm["a" /* default */].use(ajax["a" /* default */]);
vue_esm["a" /* default */].use(plugins_alert["a" /* default */]);
vue_esm["a" /* default */].use(plugins_toast["a" /* default */]);
vue_esm["a" /* default */].use(plugins_loading["a" /* default */]);
vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);
vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var routes = [{
  path: '/',
  component: src_components_Deposit
}, {
  path: '/m2',
  component: src_components_Deposit2
}, {
  path: '/m3',
  component: src_components_Deposit2Dark
}, {
  path: '/qrcode',
  name: 'deposit-qrcode',
  component: src_components_Qrcode
}, {
  path: '/finished',
  name: 'finished',
  component: src_components_Finished
}, {
  path: '/error',
  name: 'error',
  component: src_components_Error
}, {
  path: '/bankdetails',
  name: 'bankdetails',
  component: src_components_BankDetails
}, {
  path: '/helpcenter',
  name: 'helpcenter',
  component: src_components_HelpCenter
}, {
  path: '/userinfo',
  name: 'userinfo',
  component: src_components_UserInfo
}];

var mode = void 0;
if (window.location.hash === '') {
  mode = 'history';
} else {
  mode = 'hash';
}

var main_router = new vue_router_esm["a" /* default */]({
  routes: routes,
  mode: mode
});

fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

axios_default.a.defaults.withCredentials = true;

vue_esm["a" /* default */].use(src_models);

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: main_router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "PwJU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XHW0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XcBy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XwPx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cV1C":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dOfK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fFUN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g5h6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jLY8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k77+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31c83ce0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }return _vm.hide.apply(null, arguments)}}},[_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("Dj8j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: vux_src_components_x_dialog
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd202a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var alert_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})]})],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var alert_staticRenderFns = []
var alert_esExports = { render: alert_render, staticRenderFns: alert_staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (alert_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function alert_injectStyle (ssrContext) {
  __webpack_require__("g5h6")
}
var alert_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var alert___vue_template_functional__ = false
/* styles */
var alert___vue_styles__ = alert_injectStyle
/* scopeId */
var alert___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var alert___vue_module_identifier__ = null
var alert_Component = alert_normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  alert___vue_template_functional__,
  alert___vue_styles__,
  alert___vue_scopeId__,
  alert___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (alert_Component.exports);


/***/ }),

/***/ "oXsw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r/47":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7981d141","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("v0z+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "s4cR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uyKd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v0z+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b9a1287e977ea32bcb66.js